/* ── PP THEME SHIM — do not remove on FE re-sync ─────────────────────────────
 * The FE source imports these libs as ES modules (bundled by their webpack).
 * The theme instead loads their UMD builds via dist/scripts/plugins.js (see
 * assets/scripts/plugins/), which expose them as browser globals. This block
 * rebinds those globals to the local names the rest of main.js uses, so the
 * remainder of the file is byte-identical to the FE source.
 *
 * When re-syncing main.js from .frontend/src/js/main.js, replace the FE's top
 * import lines (import SplitType/PhotoSwipe/gsap/Swiper + the two CSS imports)
 * with THIS block again. We load the Swiper *bundle* UMD build, which already
 * has Navigation/EffectFade/Autoplay registered internally — so we must NOT call
 * Swiper.use() with our own module refs. (Passing empty {} placeholders to
 * Swiper.use() registers bogus modules whose lifecycle hooks then throw
 * "Cannot read properties of undefined (reading 'nextEl')" when a slider inits.)
 * The Navigation/EffectFade/Autoplay names below exist only so the FE source's
 * references resolve; they are never registered. The two CSS imports are handled
 * by the SCSS pipeline (assets/styles), not here.
 * ──────────────────────────────────────────────────────────────────────────── */
var SplitType = window.SplitType;
var PhotoSwipe = window.PhotoSwipe;
var gsap = window.gsap;
var ScrollTrigger = window.ScrollTrigger;
var Swiper = window.Swiper;
var Autoplay, EffectFade, Navigation; // bundle already registers these; do NOT Swiper.use()

if (gsap && ScrollTrigger) {
	gsap.registerPlugin(ScrollTrigger);
}

"use strict";

(function injectSprite(window, document) {
	if (!window || !document || !window.file) return;
	if (
		!document.createElementNS ||
		!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect
	) {
		return;
	}

	var isLocalStorage = "localStorage" in window && window.localStorage !== null;
	var request;
	var data;

	function insert() {
		if (document.body) {
			document.body.insertAdjacentHTML("afterbegin", data);
		} else {
			document.addEventListener("DOMContentLoaded", function () {
				document.body.insertAdjacentHTML("afterbegin", data);
			});
		}
	}

	if (isLocalStorage && localStorage.getItem("inlineSVGrev") === window.revision) {
		data = localStorage.getItem("inlineSVGdata");
		if (data) {
			insert();
			return;
		}
	}

	try {
		request = new XMLHttpRequest();
		request.open("GET", window.file, true);
		request.onload = function () {
			if (request.status >= 200 && request.status < 400) {
				data = request.responseText;
				insert();
				if (isLocalStorage) {
					localStorage.setItem("inlineSVGdata", data);
					localStorage.setItem("inlineSVGrev", window.revision);
				}
			}
		};
		request.send();
	} catch (e) {
		// noop
	}
})(window, document);

var scrollTopPos = 0;
var justClosedModal = false;
var modalIframe = null;
var bodyLockCount = 0;
var bodyLockScrollY = 0;
var lenisResizeRaf = null;
var suppressHeaderScrollUntil = 0;
var suppressPageNavSwapUntil = 0;
var splitHeadingResizeRaf = null;
var splitHeadingTargets = [];
var googleMapsLoader = null;

var SPLIT_HEADING_EASING = "power2.out";
var SPLIT_HEADING_DURATION = 1;
var SPLIT_HEADING_STAGGER = 0.11;
var GOOGLE_MAPS_WY_STYLE = [
	{ featureType: "all", elementType: "geometry.fill", stylers: [{ weight: "2.00" }] },
	{ featureType: "all", elementType: "geometry.stroke", stylers: [{ color: "#9c9c9c" }] },
	{ featureType: "all", elementType: "labels.text", stylers: [{ visibility: "on" }] },
	{ featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
	{ featureType: "landscape", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
	{ featureType: "landscape.man_made", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }] },
	{ featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
	{ featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 20 }] },
	{ featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#c9c9c9" }] },
	{ featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#5c5c5c" }] },
	{ featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
	{ featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
	{ featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
	{ featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
	{ featureType: "water", elementType: "all", stylers: [{ color: "#a8a8a8" }, { visibility: "on" }] },
	{ featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#a8a8a8" }] },
	{ featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#070707" }] },
	{ featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
];

function requestLenisResize() {
	if (!window.lenis || typeof window.lenis.resize !== "function") return;

	if (lenisResizeRaf) cancelAnimationFrame(lenisResizeRaf);
	lenisResizeRaf = requestAnimationFrame(function () {
		if (window.lenis && typeof window.lenis.resize === "function") {
			window.lenis.resize();
		}
		lenisResizeRaf = null;
	});
}

function whenFontsReady(callback) {
	if (
		document.fonts &&
		typeof document.fonts.ready === "object" &&
		typeof document.fonts.ready.then === "function"
	) {
		document.fonts.ready.then(callback);
		return;
	}

	callback();
}

function getMetaContent(name) {
	var node = document.querySelector('meta[name="' + name + '"]');

	return node ? (node.getAttribute("content") || "").trim() : "";
}

function getGoogleMapsConfig() {
	var runtimeConfig = window.MCGEES_CONFIG && window.MCGEES_CONFIG.googleMaps
		? window.MCGEES_CONFIG.googleMaps
		: null;

	return {
		apiKey: (runtimeConfig && runtimeConfig.apiKey) || window.MCGEES_GOOGLE_MAPS_API_KEY || getMetaContent("google-maps-api-key"),
		mapId: (runtimeConfig && runtimeConfig.mapId) || window.MCGEES_GOOGLE_MAPS_MAP_ID || getMetaContent("google-maps-map-id"),
	};
}

function loadGoogleMapsApi() {
	var config = getGoogleMapsConfig();

	if (window.google && window.google.maps) {
		return Promise.resolve(window.google.maps);
	}

	if (!config.apiKey) {
		return Promise.resolve(null);
	}

	if (googleMapsLoader) {
		return googleMapsLoader;
	}

	googleMapsLoader = new Promise(function (resolve, reject) {
		var script = document.createElement("script");
		var callbackName = "__mcgeesGoogleMapsReady";
		var src = "https://maps.googleapis.com/maps/api/js?key="
			+ encodeURIComponent(config.apiKey)
			+ "&v=weekly&loading=async&callback="
			+ callbackName;

		if (config.mapId) {
			src += "&map_ids=" + encodeURIComponent(config.mapId);
		}

		window[callbackName] = function () {
			delete window[callbackName];
			resolve(window.google && window.google.maps ? window.google.maps : null);
		};

		script.src = src;
		script.async = true;
		script.defer = true;
		script.onerror = function () {
			delete window[callbackName];
			reject(new Error("Google Maps failed to load"));
		};

		document.head.appendChild(script);
	});

	return googleMapsLoader;
}

function createGoogleMapsOverlayMarker(maps, map, position, markerUrl, title, markerWidth, markerHeight) {
	function OverlayMarker() {
		this.position = position;
		this.markerUrl = markerUrl;
		this.title = title;
		this.markerWidth = markerWidth;
		this.markerHeight = markerHeight;
		this.element = null;
	}

	OverlayMarker.prototype = Object.create(maps.OverlayView.prototype);
	OverlayMarker.prototype.constructor = OverlayMarker;

	OverlayMarker.prototype.onAdd = function () {
		var wrapper = document.createElement("div");
		var image = document.createElement("img");
		var width = this.markerWidth || 43;
		var height = this.markerHeight || 63;

		wrapper.style.position = "absolute";
		wrapper.style.transform = "translate(-50%, -100%)";
		wrapper.style.width = width + "px";
		wrapper.style.height = height + "px";
		wrapper.style.pointerEvents = "none";

		image.src = this.markerUrl;
		image.alt = "";
		image.width = width;
		image.height = height;
		image.style.display = "block";
		image.style.width = "100%";
		image.style.height = "100%";

		if (this.title) {
			wrapper.setAttribute("title", this.title);
		}

		wrapper.appendChild(image);
		this.element = wrapper;

		this.getPanes().overlayImage.appendChild(wrapper);
	};

	OverlayMarker.prototype.draw = function () {
		var projection = this.getProjection();
		var pixel;

		if (!projection || !this.element) return;

		pixel = projection.fromLatLngToDivPixel(this.position);
		if (!pixel) return;

		this.element.style.left = pixel.x + "px";
		this.element.style.top = pixel.y + "px";
	};

	OverlayMarker.prototype.onRemove = function () {
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}

		this.element = null;
	};

	var marker = new OverlayMarker();
	marker.setMap(map);
	return marker;
}

function isPageNavSwapSuppressed() {
	return Date.now() < suppressPageNavSwapUntil;
}

function suppressPageNavSwap(duration) {
	suppressPageNavSwapUntil = Date.now() + (duration || 1200);
}

function cancelSplitHeadingAnimations(target) {
	var state = target.__splitHeadingState;

	if (!state) return;

	if (state.timeline) {
		state.timeline.kill();
		state.timeline = null;
	}

	if (state.lineInners && state.lineInners.length) {
		gsap.killTweensOf(state.lineInners);
	}
}

function setSplitHeadingState(target, isVisible) {
	var state = target.__splitHeadingState;

	target.classList.toggle("in-view", isVisible);
	if (!state || !state.lineInners || !state.lineInners.length) return;

	state.lineInners.forEach(function (lineInner) {
		if (isVisible) {
			lineInner.style.opacity = "1";
			lineInner.style.transform = "translate3d(0, 0%, 0)";
			return;
		}

		lineInner.style.opacity = "0";
		lineInner.style.transform = "translate3d(0, 110%, 0)";
	});
}

function buildSplitHeading(target) {
	var state = target.__splitHeadingState || {};
	var lineInners = [];

	cancelSplitHeadingAnimations(target);

	if (state.instance && typeof state.instance.revert === "function") {
		state.instance.revert();
	}

	target.style.fontKerning = "none";

	state.instance = new SplitType(target, {
		types: "lines",
		tagName: "span",
		lineClass: "line",
	});

	state.lines = state.instance.lines || [];
	state.lines.forEach(function (line) {
		var inner = document.createElement("span");

		inner.className = "line__inner";

		while (line.firstChild) {
			inner.appendChild(line.firstChild);
		}

		line.appendChild(inner);
		lineInners.push(inner);
	});

	state.width = Math.round(target.getBoundingClientRect().width);
	state.isAnimated = !!state.isAnimated;
	state.lineInners = lineInners;
	setSplitHeadingState(target, state.isAnimated);

	target.__splitHeadingState = state;
	return state;
}

function animateSplitHeading(target) {
	var state = target.__splitHeadingState || buildSplitHeading(target);
	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (state.isAnimated || reduceMotion) {
		state.isAnimated = true;
		setSplitHeadingState(target, true);
		return;
	}

	cancelSplitHeadingAnimations(target);
	target.classList.add("in-view");

	if (!state.lineInners.length) {
		state.isAnimated = true;
		return;
	}

	gsap.set(state.lineInners, {
		yPercent: 110,
		opacity: 0,
		force3D: true,
	});

	state.timeline = gsap.to(state.lineInners, {
		yPercent: 0,
		opacity: 1,
		duration: SPLIT_HEADING_DURATION,
		ease: SPLIT_HEADING_EASING,
		stagger: SPLIT_HEADING_STAGGER,
		clearProps: "transform,opacity,willChange",
	});

	state.isAnimated = true;
}

function initSplitHeadings() {
	splitHeadingTargets = Array.from(document.querySelectorAll("[data-animate-text]"));

	if (!splitHeadingTargets.length) return;

	function buildAll() {
		splitHeadingTargets.forEach(function (target) {
			buildSplitHeading(target);
		});
	}

	function reveal(target) {
		animateSplitHeading(target);
	}

	function initObserver() {
		var observer;

		if (!("IntersectionObserver" in window)) {
			splitHeadingTargets.forEach(reveal);
			return;
		}

		observer = new IntersectionObserver(
			function (entries, obs) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;

					reveal(entry.target);
					obs.unobserve(entry.target);
				});
			},
			{ root: null, rootMargin: "0px 0px -12% 0px", threshold: [0, 0.12] },
		);

		splitHeadingTargets.forEach(function (target) {
			observer.observe(target);
		});
	}

	whenFontsReady(function () {
		buildAll();
		initObserver();
	});

	window.addEventListener("resize", function () {
		if (splitHeadingResizeRaf) cancelAnimationFrame(splitHeadingResizeRaf);

		splitHeadingResizeRaf = requestAnimationFrame(function () {
			splitHeadingTargets.forEach(function (target) {
				var state = target.__splitHeadingState;
				var nextWidth;

				if (!state) return;

				nextWidth = Math.round(target.getBoundingClientRect().width);
				if (nextWidth === state.width) return;

				buildSplitHeading(target);
			});

			splitHeadingResizeRaf = null;
		});
	});
}

function suppressResizeObserverLoopError() {
	if (typeof window === "undefined") return;

	var warningText = "ResizeObserver loop completed with undelivered notifications.";
	var warningTextShort = "ResizeObserver loop limit exceeded";

	function isResizeObserverWarning(message) {
		if (typeof message !== "string") return false;
		return message.indexOf(warningText) !== -1 || message.indexOf(warningTextShort) !== -1;
	}

	window.addEventListener("error", function (event) {
		if (!event || !isResizeObserverWarning(event.message)) return;
		event.preventDefault();
		event.stopImmediatePropagation();
	}, true);

	window.addEventListener("unhandledrejection", function (event) {
		var reason = event ? event.reason : null;
		var message = typeof reason === "string"
			? reason
			: reason && typeof reason.message === "string"
				? reason.message
				: "";

		if (!isResizeObserverWarning(message)) return;
		event.preventDefault();
		event.stopImmediatePropagation();
	}, true);
}

function refreshOpenAccordions(scope) {
	var root = scope || document;

	root.querySelectorAll("[data-accordion-item].is-open").forEach(function (item) {
		var panel = item.querySelector("[data-accordion-panel]");
		if (!panel) return;
		if (panel.closest("[data-accordion-item]") !== item) return;
		panel.style.maxHeight = panel.scrollHeight + "px";
		forceAccordionLayout(panel);
		syncAncestorAccordionPanels(panel);
	});

	requestLenisResize();
}

function forceAccordionLayout(panel) {
	if (!panel) return;
	panel.offsetHeight;
}

function syncAncestorAccordionPanels(panel) {
	var currentPanel = panel;

	while (currentPanel) {
		var parentItem = currentPanel.closest("[data-accordion-item]");
		var parentPanel = parentItem
			? parentItem.parentElement.closest("[data-accordion-panel]")
			: null;

		if (!parentPanel) break;

		var ownerItem = parentPanel.closest("[data-accordion-item]");
		parentPanel.style.maxHeight = ownerItem && ownerItem.classList.contains("is-open")
			? parentPanel.scrollHeight + "px"
			: "0px";

		currentPanel = parentPanel;
	}
}

function initHeaderTabs(root) {
	if (!root) return;

	var buttons = Array.from(root.querySelectorAll("[data-header-tab-button]"));
	var panels = Array.from(root.querySelectorAll("[data-header-tab-panel]"));
	var desktopMq = window.matchMedia("(min-width: 1024px)");
	var tabsColumn = root.querySelector(".header__mega-tabs");
	var panelsContainer = root.querySelector(".header__mega-panels");
	var activeId = null;
	var isTransitioning = false;
	var pendingTargetId = null;
	if (!buttons.length || !panels.length) return;

	function measureShellHeight(panel) {
		var previousHeight = root.style.height;
		var states = panels.map(function (item) {
			return {
				panel: item,
				hidden: item.hidden,
				isActive: item.classList.contains("is-active"),
				opacity: item.style.opacity,
			};
		});
		var height = 0;

		panels.forEach(function (item) {
			item.hidden = item !== panel;
			item.classList.toggle("is-active", item === panel);
			item.style.opacity = "";
		});

		root.style.height = "";
		updatePanelDependencies(panel);
		height = root.scrollHeight;

		states.forEach(function (state) {
			state.panel.hidden = state.hidden;
			state.panel.classList.toggle("is-active", state.isActive);
			state.panel.style.opacity = state.opacity;
		});

		root.style.height = previousHeight;

		return height;
	}

	function cacheShellHeight(panel) {
		if (!panel) return 0;

		var height = measureShellHeight(panel);
		panel.dataset.shellHeight = String(height);
		return height;
	}

	function cacheShellHeights() {
		panels.forEach(function (panel) {
			cacheShellHeight(panel);
		});
	}

	function getShellTargetHeight(panel) {
		var cachedHeight = Number(panel && panel.dataset ? panel.dataset.shellHeight : 0);
		return cachedHeight || cacheShellHeight(panel);
	}

	function syncShellHeight(panel) {
		if (!desktopMq.matches || !panel) {
			root.style.height = "";
			return;
		}

		root.style.height = getShellTargetHeight(panel) + "px";
	}

	function freezeShellHeight() {
		root.style.height = root.offsetHeight + "px";
		root.offsetHeight;
	}

	function updatePanelDependencies(panel) {
		if (!panel) return;

		refreshOpenAccordions(panel);
		panel.querySelectorAll(".swiper").forEach(function (slider) {
			if (slider.swiper) {
				slider.swiper.update();
			}
		});
	}

	function syncButtons(targetId) {
		buttons.forEach(function (button) {
			var isActive = button.getAttribute("data-target") === targetId;
			button.classList.toggle("is-active", isActive);
			button.setAttribute("aria-selected", isActive ? "true" : "false");
		});
	}

	function refreshPanelLayout(targetId) {
		requestAnimationFrame(function () {
			var activePanel = panels.find(function (panel) {
				return panel.id === targetId;
			});
			var accordionPanel;
			var accordionItem;
			if (activePanel) {
				updatePanelDependencies(activePanel);
				syncShellHeight(activePanel);

				if (!desktopMq.matches) {
					accordionPanel = activePanel.closest("[data-accordion-panel]");
					accordionItem = activePanel.closest("[data-accordion-item]");
					if (accordionPanel) {
						accordionPanel.style.maxHeight = accordionItem && accordionItem.classList.contains("is-open")
							? accordionPanel.scrollHeight + "px"
							: "0px";
						requestLenisResize();
					}
				}
			}
		});
	}

	function setImmediate(targetId) {
		syncButtons(targetId);

		panels.forEach(function (panel) {
			var isActive = panel.id === targetId;
			panel.getAnimations().forEach(function (animation) {
				animation.cancel();
			});
			panel.classList.toggle("is-active", isActive);
			panel.hidden = !isActive;
			panel.style.opacity = "";
		});

		activeId = targetId;
		isTransitioning = false;
		pendingTargetId = null;
		cacheShellHeights();
		refreshPanelLayout(targetId);
	}

	function activate(targetId, options) {
		var currentPanel;
		var nextPanel;
		var nextTargetId;
		var fadeOut;
		var fadeIn;

		if (!targetId) return;
		if (targetId === activeId && !isTransitioning && !(options && options.force)) {
			return;
		}

		currentPanel = panels.find(function (panel) {
			return panel.id === activeId;
		});
		nextPanel = panels.find(function (panel) {
			return panel.id === targetId;
		});

		if (!nextPanel) return;

		if (!desktopMq.matches || !currentPanel || currentPanel === nextPanel || (options && options.immediate)) {
			setImmediate(targetId);
			return;
		}

		syncButtons(targetId);

		if (isTransitioning) {
			pendingTargetId = targetId;
			return;
		}

		isTransitioning = true;
		pendingTargetId = null;
		freezeShellHeight();

		currentPanel.getAnimations().forEach(function (animation) {
			animation.cancel();
		});

		nextPanel.getAnimations().forEach(function (animation) {
			animation.cancel();
		});

		fadeOut = currentPanel.animate(
			[{ opacity: 1 }, { opacity: 0 }],
			{
				duration: 180,
				easing: "ease",
				fill: "forwards",
			},
		);

		fadeOut.onfinish = function () {
			currentPanel.classList.remove("is-active");
			currentPanel.hidden = true;
			currentPanel.style.opacity = "";

			nextPanel.hidden = false;
			nextPanel.classList.add("is-active");
			nextPanel.style.opacity = "0";

			requestAnimationFrame(function () {
				updatePanelDependencies(nextPanel);
				cacheShellHeight(nextPanel);
				freezeShellHeight();
				syncShellHeight(nextPanel);

				fadeIn = nextPanel.animate(
					[{ opacity: 0 }, { opacity: 1 }],
					{
						duration: 220,
						easing: "ease",
						fill: "forwards",
					},
				);

				fadeIn.onfinish = function () {
					nextPanel.style.opacity = "";
					activeId = targetId;
					isTransitioning = false;
					refreshPanelLayout(targetId);

					if (pendingTargetId && pendingTargetId !== activeId) {
						nextTargetId = pendingTargetId;
						pendingTargetId = null;
						activate(nextTargetId, { force: true });
						return;
					}

					pendingTargetId = null;
				};
			});
		};
	}

	buttons.forEach(function (button) {
		button.addEventListener("mouseenter", function () {
			if (!desktopMq.matches) return;
			activate(button.getAttribute("data-target"));
		});

		button.addEventListener("click", function () {
			activate(button.getAttribute("data-target"));
		});
	});

	var initial = buttons.find(function (button) {
		return button.classList.contains("is-active");
	}) || buttons[0];

	activate(initial.getAttribute("data-target"), { immediate: true });

	window.addEventListener("resize", function () {
		var activePanel = panels.find(function (panel) {
			return panel.id === activeId;
		});

		if (!desktopMq.matches) {
			root.style.height = "";
			return;
		}

		cacheShellHeights();
		syncShellHeight(activePanel);
	});
}

function initHeaderMobileMenu() {
	var header = document.querySelector(".header");
	if (!header) return;

	var toggle = header.querySelector("[data-header-mobile-toggle]");
	var menu = header.querySelector(".header__bottom");
	var megaItem = header.querySelector(".header__desktop-item--has-mega");
	var megaTrigger = megaItem
		? megaItem.querySelector("[data-accordion-trigger]")
		: null;
	var megaPanel = megaItem ? megaItem.querySelector("[data-accordion-panel]") : null;
	var mq = window.matchMedia("(min-width: 1024px)");
	var lockMq = window.matchMedia("(max-width: 767.98px)");
	var isMenuOpen = false;
	var isMenuLocked = false;

	if (!toggle || !menu) return;

	function hasOpenModals() {
		return !!document.querySelector("[data-modal].is-show");
	}

	function setMegaOpen(nextState) {
		if (!megaItem || !megaTrigger || !megaPanel) return;

		megaItem.classList.toggle("is-open", !!nextState);
		megaTrigger.setAttribute("aria-expanded", nextState ? "true" : "false");
		megaPanel.style.maxHeight = nextState ? megaPanel.scrollHeight + "px" : "0px";
		requestLenisResize();
	}

	function syncMenuLock() {
		if (isMenuLocked) {
			toggleBodyLock("unlock");
			isMenuLocked = false;
		}

		if (!hasOpenModals()) {
			document.body.classList.remove("modal-open");
		}
	}

	function setMenuOpen(nextState) {
		if (isMenuOpen === nextState) return;

		isMenuOpen = nextState;
		header.classList.toggle("is-menu-open", isMenuOpen);
		document.body.classList.toggle("is-menu-open", isMenuOpen);
		toggle.classList.toggle("is-active", isMenuOpen);
		toggle.setAttribute("aria-expanded", isMenuOpen ? "true" : "false");
		toggle.setAttribute("aria-label", isMenuOpen ? "Close menu" : "Open menu");

		if (!isMenuOpen) {
			setMegaOpen(false);
		}

		syncMenuLock();
		requestLenisResize();
	}

	toggle.addEventListener("click", function () {
		setMenuOpen(!isMenuOpen);
	});

	if (megaTrigger) {
		megaTrigger.addEventListener("keydown", function (event) {
			if (mq.matches) return;
			if (event.key !== "Enter" && event.key !== " ") return;
			event.preventDefault();
			megaTrigger.click();
		});
	}

	menu.querySelectorAll("a").forEach(function (link) {
		link.addEventListener("click", function () {
			setMenuOpen(false);
		});
	});

	document.addEventListener("keydown", function (event) {
		if (event.key !== "Escape") return;
		setMenuOpen(false);
	});

	window.addEventListener("resize", function () {
		syncMenuLock();
		requestLenisResize();
	});
}

function toggleBodyLock(action) {
	if (action === "lock") {
		bodyLockCount += 1;
		if (bodyLockCount > 1) return;

		bodyLockScrollY = window.scrollY || window.pageYOffset || 0;
		document.body.classList.add("lock", "full-lock");
		document.body.style.top = -bodyLockScrollY + "px";

		if (window.lenis && typeof window.lenis.stop === "function") {
			window.lenis.stop();
		}
		return;
	}

	bodyLockCount = Math.max(0, bodyLockCount - 1);
	if (bodyLockCount !== 0) return;

	document.body.classList.remove("lock", "full-lock");
	document.body.style.top = "";
	window.scrollTo(0, bodyLockScrollY);
	bodyLockScrollY = 0;

	if (window.lenis && typeof window.lenis.start === "function") {
		window.lenis.start();
	}
}

function createVideoIframe(videoUrl, container) {
	if (!container || !videoUrl) return null;

	var embedUrl = "";
	if (videoUrl.indexOf("youtube.com") > -1 || videoUrl.indexOf("youtu.be") > -1) {
		var parts = videoUrl.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
		var videoId = parts[2] ? parts[2].split(/[^0-9a-z_-]/i)[0] : "";
		embedUrl = "https://www.youtube.com/embed/" + videoId + "?autoplay=1&enablejsapi=1";
	} else if (videoUrl.indexOf("vimeo.com") > -1) {
		var vimeoId = videoUrl.split("/").pop();
		embedUrl = "https://player.vimeo.com/video/" + vimeoId + "?autoplay=1&api=1&background=0";
	} else {
		return null;
	}

	var iframe = document.createElement("iframe");
	iframe.src = embedUrl;
	iframe.setAttribute("allow", "autoplay; encrypted-media; fullscreen; picture-in-picture");
	iframe.setAttribute("frameborder", "0");
	iframe.setAttribute("allowfullscreen", "true");
	container.innerHTML = "";
	container.appendChild(iframe);
	return iframe;
}

function pauseVideo(iframe) {
	if (!iframe) return;
	var frameWindow = iframe.contentWindow;
	if (frameWindow) {
		if (iframe.src.indexOf("youtube.com") > -1) {
			frameWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
		}
		if (iframe.src.indexOf("vimeo.com") > -1) {
			frameWindow.postMessage('{"method":"pause"}', "*");
		}
	}
	iframe.remove();
	if (iframe === modalIframe) modalIframe = null;
}

function openModal(modalName, url) {
	var modal = document.querySelector('[data-modal="' + modalName + '"]');
	if (!modal) return;

	Array.from(document.querySelectorAll("[data-modal].is-show")).forEach(function (opened) {
		var openedName = opened.getAttribute("data-modal");
		if (openedName !== modalName) {
			closeModal(openedName, { skipScrollSync: true });
		}
	});

	modal.classList.remove("is-hide");
	modal.classList.add("is-show");
	document.body.classList.add("modal-open");

	if (modal.dataset.modalType === "iframe") {
		var container = modal.querySelector(".s-modal__iframe");
		modalIframe = createVideoIframe(url, container);
	}

	toggleBodyLock("lock");
}

function closeModal(modalName, options) {
	var modal = document.querySelector('[data-modal="' + modalName + '"]');
	if (!modal) return;
	var opts = options || {};
	var skipScrollSync = !!opts.skipScrollSync;

	if (skipScrollSync) {
		suppressHeaderScrollUntil = Date.now() + 500;
	}

	modal.classList.remove("is-show");
	modal.classList.add("is-hide");

	if (modal.dataset.modalType === "iframe") {
		pauseVideo(modalIframe);
	}

	if (!document.querySelector("[data-modal].is-show")) {
		document.body.classList.remove("modal-open");
		toggleBodyLock("unlock");
	}

	if (skipScrollSync) {
		justClosedModal = false;
		scrollTopPos = window.scrollY || window.pageYOffset || 0;
		return;
	}

	justClosedModal = true;
	window.dispatchEvent(new Event("scroll"));
}

function toggleModal(modalName, url) {
	var modal = document.querySelector('[data-modal="' + modalName + '"]');
	if (!modal) return;
	if (modal.classList.contains("is-show")) {
		closeModal(modalName);
	} else {
		openModal(modalName, url);
	}
}

function initModals() {
	document.querySelectorAll("[data-modal-toggle]").forEach(function (toggle) {
		toggle.addEventListener("click", function (event) {
			if (toggle.tagName === "A") {
				event.preventDefault();
			}
			var modalName = toggle.getAttribute("data-modal-toggle");
			var url = toggle.dataset.url !== undefined ? toggle.dataset.url : null;
			toggleModal(modalName, url);
		});
	});

	document.addEventListener("click", function (event) {
		var openModalEl = document.querySelector("[data-modal].is-show");
		if (!openModalEl) return;

		if (event.target.classList.contains("s-modal__wrapper")) {
			closeModal(openModalEl.getAttribute("data-modal"));
		}
	});

	document.addEventListener("keydown", function (event) {
		if (event.key !== "Escape") return;
		Array.from(document.querySelectorAll("[data-modal].is-show")).forEach(function (modal) {
			closeModal(modal.getAttribute("data-modal"));
		});
	});
}

function initImageModals() {
	var modal = document.querySelector('[data-modal="image"]');
	if (!modal) return;

	var image = modal.querySelector("[data-image-modal-img]");
	var title = modal.querySelector("[data-image-modal-title]");
	var text = modal.querySelector("[data-image-modal-text]");

	function openImageModal(toggle) {
		var imageSrc = toggle.getAttribute("data-modal-image") || "";
		var imageTitle = toggle.getAttribute("data-modal-title") || "";
		var imageText = toggle.getAttribute("data-modal-text") || "";

		if (image) {
			image.src = imageSrc;
			image.alt = imageTitle;
		}

		if (title) {
			title.textContent = imageTitle;
		}

		if (text) {
			text.textContent = imageText;
		}

		openModal("image");
	}

	document.addEventListener("click", function (event) {
		var toggle = event.target.closest("[data-image-modal-toggle]");
		if (!toggle) return;
		event.preventDefault();
		openImageModal(toggle);
	});

	document.addEventListener("keydown", function (event) {
		if (event.key !== "Enter" && event.key !== " ") return;
		var toggle = event.target.closest("[data-image-modal-toggle]");
		if (!toggle) return;
		event.preventDefault();
		openImageModal(toggle);
	});
}

function initAccordions() {
	var roots = Array.from(document.querySelectorAll("[data-accordion-root]"));
	if (!roots.length) return;

	roots.forEach(function (root) {
		var items = Array.from(root.querySelectorAll("[data-accordion-item]")).filter(function (item) {
			return item.closest("[data-accordion-root]") === root;
		});
		if (!items.length) return;

		var isSingle = root.hasAttribute("data-accordion-single");

		function setState(item, isOpen, skipAnimation) {
			var trigger = item.querySelector("[data-accordion-trigger]");
			var panel = item.querySelector("[data-accordion-panel]");
			if (!trigger || !panel) return;
			var hasDelayedOverflow = panel.hasAttribute("data-accordion-overflow-delayed");

			if (hasDelayedOverflow) {
				panel.classList.remove("is-overflow-visible");
			}

			item.classList.toggle("is-open", isOpen);
			trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");

			if (skipAnimation) {
				panel.style.maxHeight = isOpen ? "none" : "0px";
				if (isOpen) {
					requestAnimationFrame(function () {
						panel.style.maxHeight = panel.scrollHeight + "px";
						if (hasDelayedOverflow) {
							panel.classList.add("is-overflow-visible");
						}
						forceAccordionLayout(panel);
						syncAncestorAccordionPanels(panel);
						requestLenisResize();
					});
				} else {
					forceAccordionLayout(panel);
					syncAncestorAccordionPanels(panel);
					requestLenisResize();
				}
				return;
			}

			panel.style.maxHeight = isOpen ? panel.scrollHeight + "px" : "0px";
			forceAccordionLayout(panel);
			syncAncestorAccordionPanels(panel);
			requestLenisResize();
		}

		items.forEach(function (item) {
			setState(item, item.classList.contains("is-open"), true);
			var trigger = item.querySelector("[data-accordion-trigger]");
			if (!trigger) return;
			var panel = item.querySelector("[data-accordion-panel]");
				if (panel) {
					panel.addEventListener("transitionend", function (event) {
						if (event.propertyName !== "max-height") return;
						if (panel.hasAttribute("data-accordion-overflow-delayed")) {
							panel.classList.toggle("is-overflow-visible", item.classList.contains("is-open"));
						}
						forceAccordionLayout(panel);
						syncAncestorAccordionPanels(panel);
						requestLenisResize();
					});
				}

			trigger.addEventListener("click", function () {
				var willOpen = !item.classList.contains("is-open");
				if (isSingle && willOpen) {
					items.forEach(function (otherItem) {
						if (otherItem === item) return;
						setState(otherItem, false, false);
					});
				}
				setState(item, willOpen, false);
			});
		});

		window.addEventListener("resize", function () {
			items.forEach(function (item) {
				if (!item.classList.contains("is-open")) return;
				var panel = item.querySelector("[data-accordion-panel]");
				if (!panel) return;
				panel.style.maxHeight = panel.scrollHeight + "px";
				forceAccordionLayout(panel);
				syncAncestorAccordionPanels(panel);
			});
			requestLenisResize();
		});
	});
}

function initHeaderScroll() {
	var header = document.querySelector(".header");
	if (!header) return;

	var wrapper = document.querySelector(".header-wrapper");
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");
	var lastScrollY = window.scrollY || window.pageYOffset || 0;
	var ticking = false;
	var updateHeaderStickyOffset = function () {
		var headerHeight = header ? header.offsetHeight : 0;
		var stickyOffset = headerHeight + 32;

		document.documentElement.style.setProperty(
			"--header-sticky-offset",
			stickyOffset + "px",
		);
	};
	var updateJournalFeedStickyOffset = function () {
		var hasStickyAside = window.matchMedia("(min-width: 768px)").matches;
		var stickyOffset = 32;
		var headerHeight = header ? header.offsetHeight : 0;
		var visibleAnchorNav = document.querySelector("[data-page-nav-sticky].is-stuck.is-visible");
		var anchorNavHeight = visibleAnchorNav ? visibleAnchorNav.offsetHeight : 0;

		if (hasStickyAside) {
			stickyOffset = headerHeight + 32;
		}

		if (hasStickyAside && anchorNavHeight) {
			stickyOffset += anchorNavHeight;
		}

		document.documentElement.style.setProperty(
			"--journal-feed-sticky-top",
			stickyOffset + "px",
		);
	};
	var updateHeaderOffset = function () {
		if (!wrapper) return;
		var headerOffset = wrapper.getBoundingClientRect().top;
		document.body.style.setProperty(
			"--header-offset",
			(headerOffset > 0 ? headerOffset : 0) + "px",
		);
	};

	updateHeaderOffset();
	updateHeaderStickyOffset();
	updateJournalFeedStickyOffset();
	window.updateHeaderOffset = updateHeaderOffset;
	window.updateHeaderStickyOffset = updateHeaderStickyOffset;
	window.updateJournalFeedStickyOffset = updateJournalFeedStickyOffset;

	if (wrapper) {
		wrapper.classList.add("is-header-fixed");
	}

	function syncHeaderState() {
		var currentScrollY = window.scrollY || window.pageYOffset || 0;
		var isMenuOpen = header.classList.contains("is-menu-open");
		var shouldShow = true;

		header.classList.toggle("is-fixed", currentScrollY > 0);

		if (wrapper && wrapper.classList.contains("header-wrapper--main")) {
			var isHomepage = document.body.classList.contains("home");
			wrapper.classList.toggle("is-scrolled-in", !isHomepage || currentScrollY >= 500);
		}

		if (mobileQuery.matches && !isMenuOpen) {
			if (currentScrollY <= 0) {
				shouldShow = true;
			} else if (currentScrollY < lastScrollY - 2) {
				shouldShow = true;
			} else if (currentScrollY > lastScrollY + 2) {
				shouldShow = false;
			} else {
				shouldShow = header.classList.contains("is-active");
			}
		}

		header.classList.toggle("is-active", shouldShow || isMenuOpen || !mobileQuery.matches);
		lastScrollY = currentScrollY;
		ticking = false;
	}

	function requestHeaderSync() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(syncHeaderState);
	}

	syncHeaderState();

	window.addEventListener("resize", function () {
		updateHeaderOffset();
		updateHeaderStickyOffset();
		updateJournalFeedStickyOffset();
		lastScrollY = window.scrollY || window.pageYOffset || 0;
		syncHeaderState();
	});

	window.addEventListener("scroll", requestHeaderSync, { passive: true });
}

function initLenis() {
	if (typeof Lenis === "undefined") return;

	var desktopMq = window.matchMedia("(min-width: 1024px)");
	var rafId = null;

	function createLenis() {
		var lenis;

		if (window.lenis || !desktopMq.matches) return;

		lenis = new Lenis({
			smoothWheel: true,
			smoothTouch: false,
			lerp: 0.1,
			autoResize: false,
		});

		window.lenis = lenis;
		if (document.body.classList.contains("is-home-preloading") && typeof lenis.stop === "function") {
			lenis.stop();
		}
		requestLenisResize();

		function raf(time) {
			if (!window.lenis) {
				rafId = null;
				return;
			}

			lenis.raf(time);
			rafId = requestAnimationFrame(raf);
		}

		rafId = requestAnimationFrame(raf);
	}

	function destroyLenis() {
		if (!window.lenis) return;

		if (rafId) {
			cancelAnimationFrame(rafId);
			rafId = null;
		}

		window.lenis.destroy();
		window.lenis = null;
	}

	function syncLenis() {
		if (desktopMq.matches) {
			createLenis();
			return;
		}

		destroyLenis();
	}

	window.addEventListener("resize", function () {
		requestLenisResize();
	});

	desktopMq.addEventListener("change", syncLenis);
	syncLenis();
}

function initPageNav() {
	var roots = Array.from(document.querySelectorAll("[data-page-nav-root]"));
	if (!roots.length) return;

	function scrollY() {
		return window.scrollY || window.pageYOffset || 0;
	}

	function headerAnchorOffset(root) {
		var header = document.querySelector(".header");
		var stickyNav = root ? root.querySelector("[data-page-nav-sticky]") : null;
		var isMobile = window.matchMedia("(max-width: 767.98px)").matches;
		var headerHeight = header ? header.offsetHeight : (isMobile ? 74 : 84);
		var navHeight = stickyNav ? stickyNav.offsetHeight : 0;

		return headerHeight + navHeight + (isMobile ? 12 : 20);
	}

	function sectionTop(section) {
		return section.getBoundingClientRect().top + scrollY();
	}

	function scrollToSection(section, root) {
		var offset = headerAnchorOffset(root);
		var top = sectionTop(section) - offset;
		suppressPageNavSwap();

		if (window.lenis && typeof window.lenis.scrollTo === "function") {
			window.lenis.scrollTo(section, {
				offset: -offset,
			});
		} else {
			window.scrollTo({
				top: top,
				behavior: "smooth",
			});
		}

		if (history && typeof history.pushState === "function") {
			history.pushState(null, "", "#" + section.id);
		}
	}

	roots.forEach(function (root) {
		var sections = Array.from(root.querySelectorAll("[data-page-nav-section]"));
		var links = Array.from(root.querySelectorAll("[data-page-nav-link]"));
		var dropdown = root.querySelector("[data-page-nav-dropdown]");
		var toggle = root.querySelector("[data-page-nav-toggle]");
		var selected = root.querySelector("[data-page-nav-selected]");
		var options = Array.from(root.querySelectorAll("[data-page-nav-option]"));
		var glider = root.querySelector("[data-page-nav-glider]");
		var stickyNav = root.querySelector("[data-page-nav-sticky]");
		var mobilePanel = root.querySelector(".s-anchor-nav__panel");
		var mobileHead = root.querySelector(".s-anchor-nav__mobile-head");
		var ticking = false;
		var stickyTicking = false;
		var lastScrollY = scrollY();

		if (!sections.length) return;

		function sectionById(id) {
			return sections.find(function (section) {
				return section.id === id;
			});
		}

		function labelForSection(section) {
			var option = options.find(function (item) {
				return item.getAttribute("data-target") === section.id;
			});
			var link = links.find(function (item) {
				return item.getAttribute("href") === "#" + section.id;
			});

			return (option || link || section).textContent.trim();
		}

		function moveGlider(link) {
			if (!glider || !link) return;

			glider.style.width = link.offsetWidth + "px";
			glider.style.transform = "translateX(" + link.offsetLeft + "px)";
		}

		function isStackedMobile() {
			return (
				stickyNav &&
				stickyNav.classList.contains("s-anchor-nav--stacked-mobile") &&
				window.matchMedia("(max-width: 767.98px)").matches
			);
		}

		function syncMobilePanelState() {
			if (!mobilePanel || !mobileHead) return;

			if (!isStackedMobile()) {
				mobilePanel.classList.remove("is-open");
				mobileHead.setAttribute("aria-expanded", "false");
				var desktopPanel = mobilePanel.querySelector("[data-accordion-panel]");
				if (desktopPanel) {
					desktopPanel.style.removeProperty("max-height");
				}
				return;
			}

			var mobilePanelBody = mobilePanel.querySelector("[data-accordion-panel]");
			if (mobilePanelBody && !mobilePanel.classList.contains("is-open")) {
				mobilePanelBody.style.maxHeight = "0px";
			}
		}

		function setDropdownState(isOpen) {
			if (!dropdown || !toggle) return;
			dropdown.classList.toggle("is-open", isOpen);
			toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
		}

		function setActive(section) {
			var activeLink = null;

			if (!section) return;

			links.forEach(function (link) {
				var isActive = link.getAttribute("href") === "#" + section.id;
				link.classList.toggle("is-active", isActive);
				if (isActive) {
					activeLink = link;
				}
				if (isActive) {
					link.setAttribute("aria-current", "true");
				} else {
					link.removeAttribute("aria-current");
				}
			});

			options.forEach(function (option) {
				var isActive = option.getAttribute("data-target") === section.id;
				option.classList.toggle("is-active", isActive);
				option.setAttribute("aria-pressed", isActive ? "true" : "false");
			});

			if (selected) {
				selected.textContent = labelForSection(section);
			}

			moveGlider(activeLink);
		}

		function currentSection() {
			var threshold = scrollY() + headerAnchorOffset(root) + 24;
			var current = sections[0];

			sections.forEach(function (section) {
				if (sectionTop(section) <= threshold) {
					current = section;
				}
			});

			return current;
		}

		function updateActive() {
			setActive(currentSection());
		}

		function updateStickyState() {
			if (!stickyNav) return;

			var currentY = scrollY();
			var deltaY = currentY - lastScrollY;
			var sectionStart = sectionTop(root) - (document.querySelector(".header") ? document.querySelector(".header").offsetHeight : 0);
			var isPastStart = currentY > sectionStart;

			stickyNav.classList.toggle("is-stuck", isPastStart);

			if (isPageNavSwapSuppressed()) {
				stickyNav.classList.add("is-visible");
				lastScrollY = currentY;
				return;
			}

			if (!isPastStart) {
				stickyNav.classList.add("is-visible");
				lastScrollY = currentY;
				return;
			}

			if (deltaY > 2) {
				stickyNav.classList.add("is-visible");
			} else if (deltaY < -2) {
				stickyNav.classList.remove("is-visible");
			}

			if (typeof window.updateJournalFeedStickyOffset === "function") {
				window.updateJournalFeedStickyOffset();
			}

			lastScrollY = currentY;
		}

		function requestUpdate() {
			if (ticking) return;

			ticking = true;
			requestAnimationFrame(function () {
				updateActive();
				ticking = false;
			});
		}

		function requestStickyUpdate() {
			if (!stickyNav || stickyTicking) return;

			stickyTicking = true;
			requestAnimationFrame(function () {
				updateStickyState();
				stickyTicking = false;
			});
		}

		links.forEach(function (link) {
			link.addEventListener("click", function (event) {
				var id = link.getAttribute("href").replace("#", "");
				var section = sectionById(id);

				if (!section) return;
				event.preventDefault();
				setActive(section);
				if (isStackedMobile() && mobilePanel && mobileHead && mobilePanel.classList.contains("is-open")) {
					mobileHead.click();
				}
				scrollToSection(section, root);
			});
		});

		options.forEach(function (option) {
			option.addEventListener("click", function () {
				var section = sectionById(option.getAttribute("data-target"));

				if (!section) return;
				setActive(section);
				setDropdownState(false);
				scrollToSection(section, root);
			});
		});

		if (toggle) {
			toggle.addEventListener("click", function () {
				setDropdownState(!(dropdown && dropdown.classList.contains("is-open")));
			});
		}

		if (mobileHead && mobilePanel) {
			syncMobilePanelState();
		}

		document.addEventListener("click", function (event) {
			if (!dropdown || dropdown.contains(event.target)) return;
			setDropdownState(false);
		});

		document.addEventListener("keydown", function (event) {
			if (event.key !== "Escape") return;
			setDropdownState(false);
		});

		window.addEventListener("scroll", requestUpdate, { passive: true });
		window.addEventListener("scroll", requestStickyUpdate, { passive: true });
		window.addEventListener("resize", function () {
			requestUpdate();
			requestStickyUpdate();
			syncMobilePanelState();
			if (typeof window.updateJournalFeedStickyOffset === "function") {
				window.updateJournalFeedStickyOffset();
			}
		});
		updateActive();
		updateStickyState();
		syncMobilePanelState();

		if (window.location.hash) {
			var hashSection = sectionById(window.location.hash.replace("#", ""));
			if (hashSection) {
				setTimeout(function () {
					setActive(hashSection);
					scrollToSection(hashSection, root);
				}, 80);
			}
		}
	});
}

function initAnchorNavs() {
	var navs = Array.from(document.querySelectorAll("[data-anchor-nav]"));

	if (!navs.length) return;

	function getScrollOffset() {
		var header = document.querySelector(".header");
		var isMobile = window.matchMedia("(max-width: 767.98px)").matches;
		var headerHeight = header ? header.offsetHeight : 0;

		return headerHeight + (isMobile ? 16 : 24);
	}

	navs.forEach(function (nav) {
		var links = Array.from(nav.querySelectorAll("[data-anchor-link][href^='#']"));

		if (!links.length) return;

		nav.addEventListener("click", function (event) {
			var link = event.target.closest("[data-anchor-link][href^='#']");
			var targetSelector;
			var target;
			var offset;

			if (!link || !nav.contains(link)) return;

			targetSelector = link.getAttribute("href");
			if (!targetSelector || targetSelector === "#") return;

			target = document.querySelector(targetSelector);
			if (!target) return;

			event.preventDefault();
			offset = getScrollOffset();

			links.forEach(function (item) {
				var isActive = item === link;

				item.classList.toggle("is-active", isActive);
				if (isActive) {
					item.setAttribute("aria-current", "true");
				} else {
					item.removeAttribute("aria-current");
				}
			});

			if (window.lenis && typeof window.lenis.scrollTo === "function") {
				window.lenis.scrollTo(target, {
					offset: -offset,
				});
			} else {
				window.scrollTo({
					top: target.getBoundingClientRect().top + window.pageYOffset - offset,
					behavior: "smooth",
				});
			}

			if (history && typeof history.pushState === "function") {
				history.pushState(null, "", targetSelector);
			}
		});
	});
}

function initLocalOfficeAboutPeopleTicker() {
	var tickers = Array.from(document.querySelectorAll("[data-local-office-about-people-ticker]"));

	if (!tickers.length) return;

	function updateTicker(ticker) {
		var content = ticker.querySelector("[data-local-office-about-people-ticker-content]");
		var firstTrack;
		var gap;
		var distance;

		if (!content) return;

		firstTrack = content.querySelector(".s-local-office-about-people__ticker-track");
		if (!firstTrack) return;

		gap = parseFloat(window.getComputedStyle(content).columnGap || window.getComputedStyle(content).gap || "0") || 0;
		distance = firstTrack.getBoundingClientRect().width + gap;
		content.style.setProperty("--ticker-loop-distance", distance.toFixed(2) + "px");
	}

	function requestUpdate() {
		tickers.forEach(updateTicker);
	}

	window.addEventListener("resize", requestUpdate);
	whenFontsReady(requestUpdate);
	requestUpdate();
}

function initPartnersTicker() {
	var tickers = Array.from(document.querySelectorAll("[data-partners-ticker]"));

	if (!tickers.length) return;

	function updateTicker(ticker) {
		var content = ticker.querySelector("[data-partners-ticker-content]");
		var firstTrack;
		var gap;
		var distance;

		if (!content) return;

		firstTrack = content.querySelector(".s-trusted-partners__ticker-track");
		if (!firstTrack) return;

		gap = parseFloat(window.getComputedStyle(content).columnGap || window.getComputedStyle(content).gap || "0") || 0;
		distance = firstTrack.getBoundingClientRect().width + gap;
		content.style.setProperty("--ticker-loop-distance", distance.toFixed(2) + "px");
	}

	function requestUpdate() {
		tickers.forEach(updateTicker);
	}

	window.addEventListener("resize", requestUpdate);
	whenFontsReady(requestUpdate);
	requestUpdate();
}

function initLocalOfficeAboutStory() {
	var sections = Array.from(document.querySelectorAll("[data-about-story]"));
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");
	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
	var ticking = false;

	if (!sections.length) return;

	function clamp(value, min, max) {
		return Math.min(Math.max(value, min), max);
	}

	function getPageTop(element) {
		return element.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
	}

	function resetSection(section) {
		var viewport = section.querySelector("[data-about-story-viewport]");
		var items = Array.from(section.querySelectorAll("[data-about-story-item]"));

		section.classList.remove("is-fixed", "is-ended");
		section.style.removeProperty("min-height");
		section.style.removeProperty("--about-story-height");

		if (viewport) {
			viewport.style.removeProperty("height");
		}

		items.forEach(function (item) {
			var image = item.querySelector("[data-about-story-image]");

			item.style.removeProperty("transform");
			item.style.removeProperty("opacity");

			if (image) {
				image.style.removeProperty("transform");
			}
		});
	}

	function updateSection(section) {
		var viewport = section.querySelector("[data-about-story-viewport]");
		var items = Array.from(section.querySelectorAll("[data-about-story-item]"));
		var viewportHeight = window.innerHeight;
		var start = getPageTop(section);
		var scrollY = window.scrollY || window.pageYOffset || 0;
		var frameScrollHeight;
		var sectionHeight;
		var end;
		var progress;
		var sectionProgress;

		if (!viewport || !items.length) return;

		section.style.setProperty("--about-story-height", viewportHeight + "px");
		viewport.style.height = viewportHeight + "px";
		frameScrollHeight = items[0].offsetHeight || Math.round(viewportHeight * 1.3);
		sectionHeight = frameScrollHeight * items.length;
		end = start + sectionHeight - viewportHeight;
		progress = clamp((scrollY - start) / Math.max(frameScrollHeight, 1), 0, items.length - 1);
		sectionProgress = clamp((scrollY - start) / Math.max(end - start, 1), 0, 1);
		section.style.minHeight = sectionHeight + "px";

		section.classList.toggle("is-fixed", scrollY >= start && scrollY < end);
		section.classList.toggle("is-ended", scrollY >= end);

		items.forEach(function (item, index) {
			var image = item.querySelector("[data-about-story-image]");
			var frame = image ? image.parentElement : null;
			var entryProgress = index === 0 ? 1 : clamp(progress - (index - 1), 0, 1);
			var translateY = index === 0 ? 0 : (1 - entryProgress) * 100;
			var maxParallaxOffset = 0;
			var parallaxOffset = 0;

			if (image && frame) {
				maxParallaxOffset = Math.max((image.offsetHeight - frame.offsetHeight) / 2, 0);
				parallaxOffset = -(sectionProgress * maxParallaxOffset);
			}

			if (scrollY < start) {
				translateY = index === 0 ? 0 : 100;
				parallaxOffset = 0;
			} else if (scrollY >= end) {
				translateY = 0;
				parallaxOffset = -maxParallaxOffset;
			}

			item.style.transform = "translate3d(0, " + translateY.toFixed(3) + "%, 0)";

			if (image) {
				image.style.transform = "translate3d(0, " + parallaxOffset.toFixed(2) + "px, 0)";
			}
		});
	}

	function update() {
		sections.forEach(function (section) {
			if (mobileQuery.matches || reduceMotion.matches) {
				resetSection(section);
				return;
			}

			updateSection(section);
		});

		ticking = false;
	}

	function requestUpdate() {
		if (ticking) return;

		ticking = true;
		requestAnimationFrame(update);
	}

	window.addEventListener("scroll", requestUpdate, { passive: true });
	window.addEventListener("resize", function () {
		requestUpdate();
		requestLenisResize();
	});

	if (mobileQuery.addEventListener) {
		mobileQuery.addEventListener("change", requestUpdate);
	} else if (mobileQuery.addListener) {
		mobileQuery.addListener(requestUpdate);
	}

	if (reduceMotion.addEventListener) {
		reduceMotion.addEventListener("change", requestUpdate);
	} else if (reduceMotion.addListener) {
		reduceMotion.addListener(requestUpdate);
	}

	update();
}

function initEbooksSliders() {
	document.querySelectorAll(".js-ebooks-slider").forEach(function (slider) {
		var section = slider.closest(".s-ebooks");
		var prev = section ? section.querySelector("[data-ebooks-prev]") : null;
		var next = section ? section.querySelector("[data-ebooks-next]") : null;
		var progressFill = section ? section.querySelector("[data-ebooks-progress-fill]") : null;

		if (!slider) return;

		function updateProgress(swiper) {
			if (!progressFill) return;

			var maxIndex = Math.max(slidesCount - 1, 1);
			var currentIndex = Math.max(0, Math.min(swiper.realIndex || 0, maxIndex));
			var percent = swiper.isLocked ? 100 : (currentIndex / maxIndex) * 100;
			progressFill.style.width = percent.toFixed(2) + "%";
		}

		var swiper = new Swiper(slider, {
			slidesPerView: "auto",
			spaceBetween: 0,
			watchOverflow: true,
			watchSlidesProgress: true,
			resizeObserver: false,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			on: {
				init: function (instance) {
					updateProgress(instance);
				},
				slideChange: function (instance) {
					updateProgress(instance);
				},
				setTranslate: function (instance) {
					updateProgress(instance);
				},
				resize: function (instance) {
					updateProgress(instance);
				},
				breakpoint: function (instance) {
					updateProgress(instance);
				},
			},
		});

		updateProgress(swiper);
	});
}

function initProducerMentionSliders() {
	document.querySelectorAll(".js-producer-mentions-slider").forEach(function (slider) {
		var section = slider.closest(".s-journal-producers");
		var prev = section ? section.querySelector("[data-producer-mentions-prev]") : null;
		var next = section ? section.querySelector("[data-producer-mentions-next]") : null;
		var progressFill = section ? section.querySelector("[data-producer-mentions-progress-fill]") : null;
		var slidesCount = slider.querySelectorAll(".swiper-slide").length;

		if (!slider) return;

		function updateProgress(swiper) {
			if (!progressFill) return;

			var percent = swiper.isLocked ? 100 : Math.max(0, Math.min(swiper.progress * 100, 100));
			progressFill.style.width = percent.toFixed(2) + "%";
		}

		var swiper = new Swiper(slider, {
			loop: true,
			loopedSlides: slidesCount,
			loopAdditionalSlides: slidesCount,
			slidesPerView: "auto",
			spaceBetween: 1,
			watchOverflow: true,
			watchSlidesProgress: true,
			resizeObserver: false,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				1024: {
					slidesPerView: 4,
					allowTouchMove: false,
				},
			},
			on: {
				init: function (instance) {
					updateProgress(instance);
				},
				slideChange: function (instance) {
					updateProgress(instance);
				},
				setTranslate: function (instance) {
					updateProgress(instance);
				},
				resize: function (instance) {
					updateProgress(instance);
				},
				breakpoint: function (instance) {
					updateProgress(instance);
				},
			},
		});

		updateProgress(swiper);
	});
}

function initJournalFeed() {
	var sections = Array.from(document.querySelectorAll("[data-journal-feed]"));
	if (!sections.length) return;

	function escapeHtml(value) {
		return String(value || "")
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/\"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}

	function renderPagination(pagination, page, totalPages) {
		var pagesMarkup = "";
		var prevDisabled = page <= 1 ? " disabled" : "";
		var nextDisabled = page >= totalPages ? " disabled" : "";

		function getPageItems() {
			var items = [];

			if (totalPages <= 6) {
				for (var all = 1; all <= totalPages; all += 1) {
					items.push(all);
				}
				return items;
			}

			if (page <= 3) {
				return [1, 2, 3, 4, { type: "ellipsis", key: "end", page: 5 }, totalPages];
			}

			if (page >= totalPages - 2) {
				return [
					1,
					{ type: "ellipsis", key: "start", page: totalPages - 4 },
					totalPages - 3,
					totalPages - 2,
					totalPages - 1,
					totalPages,
				];
			}

			return [
				1,
				{ type: "ellipsis", key: "start", page: page - 1 },
				page,
				page + 1,
				{ type: "ellipsis", key: "end", page: page + 2 },
				totalPages,
			];
		}

		if (totalPages <= 1) {
			pagination.hidden = true;
			pagination.innerHTML = "";
			return;
		}

		getPageItems().forEach(function (item) {
			if (typeof item === "object" && item.type === "ellipsis") {
				pagesMarkup +=
					'<button class="b-pagination__page b-pagination__ellipsis" type="button" data-journal-page="' +
					item.page +
					'" aria-label="Go to page ' +
					item.page +
					'">...</button>';
				return;
			}

			pagesMarkup +=
				'<button class="b-pagination__page' +
				(item === page ? " is-active" : "") +
				'" type="button" data-journal-page="' +
				item +
				'"' +
				(item === page ? ' aria-current="page"' : "") +
				">" +
				item +
				"</button>";
		});

		pagination.hidden = false;
		pagination.innerHTML =
			'<button class="b-pagination__arrow b-pagination__arrow--prev" type="button" data-journal-prev aria-label="Previous page"' +
			prevDisabled +
			'>' +
			'<svg aria-hidden="true"><use xlink:href="#icon-pagination-arrow"></use></svg>' +
			"</button>" +
			'<div class="b-pagination__pages">' +
			pagesMarkup +
			"</div>" +
			'<button class="b-pagination__arrow b-pagination__arrow--next" type="button" data-journal-next aria-label="Next page"' +
			nextDisabled +
			'>' +
			'<svg aria-hidden="true"><use xlink:href="#icon-pagination-arrow"></use></svg>' +
			"</button>";
	}

	sections.forEach(function (section) {
		var source = section.getAttribute("data-source");
		var results = section.querySelector("[data-journal-results]");
		var pagination = section.querySelector("[data-journal-pagination]");
		var filterOptions = Array.from(section.querySelectorAll("[data-journal-filter-options]"));
		var resultsWrap = section.querySelector(".s-journal-feed__results-wrap");
		var spinner = section.querySelector(".s-journal-feed__spinner");
		var requestId = 0;
		var loadingTimer = null;
		var revealTimer = null;
		var resizeRaf = null;
		var spinnerRaf = null;
		var spinnerLockedTop = "";
		var filterConfigs = filterOptions.map(function (node) {
			var item = node.closest(".s-journal-feed__filter-item");
			var toggleLabel = item ? item.querySelector(".s-journal-feed__filter-toggle > span:first-child") : null;
			var hasParentFilter = !!(item && item.hasAttribute("data-journal-parent-filter"));

			return {
				name: node.getAttribute("data-journal-filter-options"),
				inputType: node.getAttribute("data-journal-input-type") || "checkbox",
				valuesKey: node.getAttribute("data-journal-values-key") || "",
				matchKey: node.getAttribute("data-journal-match-key") || "",
				group: node.getAttribute("data-journal-filter-group") || "",
				hasParentFilter: hasParentFilter,
				toggleLabel: toggleLabel,
				node: node,
			};
		});
		var state = {
			page: 1,
			isBootstrapped: false,
			data: null,
			filters: {},
		};

		if (!source || !results || !filterConfigs.length || !resultsWrap || !spinner) return;

		filterConfigs.forEach(function (config) {
			state.filters[config.name] = config.inputType === "radio" ? "All" : [];
		});

		function resetFilters() {
			filterConfigs.forEach(function (config) {
				state.filters[config.name] = config.inputType === "radio" ? "All" : [];

				Array.from(
					section.querySelectorAll('.s-journal-feed__check-input[name="' + config.name + '"]'),
				).forEach(function (input) {
					if (config.inputType === "radio") {
						input.checked = input.value === "All";
						return;
					}

					input.checked = false;
				});
			});

			state.page = 1;
			updateGroupedParentStates();
			updateSimpleFilterCounts();
		}

		function updateSimpleFilterCounts() {
			filterConfigs.forEach(function (config) {
				var count = 0;

				if (!config.toggleLabel || config.hasParentFilter) return;

				if (config.inputType === "radio") {
					count = state.filters[config.name] && state.filters[config.name] !== "All" ? 1 : 0;
				} else if (Array.isArray(state.filters[config.name])) {
					count = state.filters[config.name].length;
				}

				if (count > 0) {
					config.toggleLabel.setAttribute("data-selected-count", String(count));
					config.toggleLabel.classList.add("has-selected-count");
					return;
				}

				config.toggleLabel.removeAttribute("data-selected-count");
				config.toggleLabel.classList.remove("has-selected-count");
			});
		}

		function updateSpinnerPosition() {
			if (spinnerLockedTop) {
				resultsWrap.style.setProperty("--journal-feed-spinner-top", spinnerLockedTop);
				return;
			}

			var rect = resultsWrap.getBoundingClientRect();
			var visibleTop = Math.max(rect.top, 0);
			var visibleBottom = Math.min(rect.bottom, window.innerHeight);
			var visibleHeight = Math.max(visibleBottom - visibleTop, 0);
			var centerInWrap = 0;

			if (!visibleHeight) {
				centerInWrap = Math.min(Math.max(window.innerHeight / 2 - rect.top, 20), Math.max(rect.height - 20, 20));
			} else {
				centerInWrap = ((visibleTop + visibleBottom) / 2) - rect.top;
			}

			resultsWrap.style.setProperty("--journal-feed-spinner-top", centerInWrap.toFixed(2) + "px");
		}

		function requestSpinnerPosition() {
			if (spinnerRaf) return;

			spinnerRaf = requestAnimationFrame(function () {
				updateSpinnerPosition();
				spinnerRaf = null;
			});
		}

		function getItemsPerPage() {
			if (window.matchMedia("(max-width: 767.98px)").matches) {
				return section.classList.contains("s-journal-feed--ejournals") ? 6 : 7;
			}

			return 12;
		}

		function updateGroupedParentStates() {
			if (!section.querySelector("[data-journal-parent-filter]")) return;

			Array.from(section.querySelectorAll("[data-journal-parent-filter]")).forEach(function (item) {
				var filterName = item.getAttribute("data-journal-parent-filter");
				var parentButton = item.querySelector("[data-journal-parent-toggle]");
				var inputs = Array.from(
					item.querySelectorAll('.s-journal-feed__check-input[name="' + filterName + '"]'),
				);
				var checkedCount = inputs.filter(function (input) {
					return input.checked;
				}).length;
				var total = inputs.length;
				var isAllChecked = total > 0 && checkedCount === total;
				var isPartial = checkedCount > 0 && checkedCount < total;

				item.classList.toggle("is-parent-checked", isAllChecked);
				item.classList.toggle("is-parent-partial", isPartial);

				if (parentButton) {
					parentButton.setAttribute("aria-pressed", isAllChecked ? "true" : "false");
				}
			});
		}

		function renderFilterOptions(config, values) {
			var groupValues = values.slice();

			if (config.inputType === "radio" && groupValues.indexOf("All") === -1) {
				groupValues.unshift("All");
			}

			return groupValues.map(function (value) {
				var checked = "";

				if (config.inputType === "radio" && state.filters[config.name] === value) {
					checked = ' checked';
				}

				if (
					config.inputType !== "radio" &&
					Array.isArray(state.filters[config.name]) &&
					state.filters[config.name].indexOf(value) !== -1
				) {
					checked = ' checked';
				}

				return (
					'<label class="s-journal-feed__check' +
						(config.inputType === "radio" ? " s-journal-feed__check--radio" : "") +
						'">' +
						'<input class="s-journal-feed__check-input" type="' +
						(config.inputType === "radio" ? "radio" : "checkbox") +
						'" name="' +
						config.name +
						'" value="' +
						escapeHtml(value) +
						'"' +
						checked +
						'>' +
						'<span class="s-journal-feed__check-box" aria-hidden="true"></span>' +
						'<span class="s-journal-feed__check-text">' +
							escapeHtml(value) +
						"</span>" +
					"</label>"
				);
			}).join("");
		}

		function ensureFilters(data) {
			if (state.isBootstrapped) return;

			filterConfigs.forEach(function (config) {
				var values = data[config.valuesKey || (config.name + "s")] || [];
				config.node.innerHTML = renderFilterOptions(config, values);
			});

			state.isBootstrapped = true;
			updateGroupedParentStates();
			updateSimpleFilterCounts();
			refreshOpenAccordions(section);
		}

		function filterArticles(items) {
			return items.filter(function (article) {
				var groupedValues = {};

				filterConfigs.forEach(function (config) {
					var value = state.filters[config.name];
					var matchKey = config.matchKey || config.name;
					var groupKey = config.group || config.name;

					if (config.inputType === "radio") {
						if (!value || value === "All") return;
						if (!groupedValues[groupKey]) {
							groupedValues[groupKey] = { inputType: config.inputType, matchKey: matchKey, values: [] };
						}
						groupedValues[groupKey].values = [value];
						return;
					}

					if (!Array.isArray(value) || !value.length) return;
					if (!groupedValues[groupKey]) {
						groupedValues[groupKey] = { inputType: config.inputType, matchKey: matchKey, values: [] };
					}
					groupedValues[groupKey].values = groupedValues[groupKey].values.concat(value);
				});

				return Object.keys(groupedValues).every(function (groupKey) {
					var groupConfig = groupedValues[groupKey];
					var values = Array.from(new Set(groupConfig.values));

					if (!values.length) return true;
					return values.indexOf(article[groupConfig.matchKey]) !== -1;
				});
			});
		}

		function renderEmptyState() {
			results.innerHTML =
				'<div class="s-journal-feed__empty-state">' +
					'<p class="s-journal-feed__empty">No articles found for the selected filters.</p>' +
					'<button class="btn s-journal-feed__empty-button" type="button" data-journal-clear-filters>' +
						'<span class="btn__label">Clear Filters</span>' +
						'<span class="btn__copy" aria-hidden="true"><span>Clear Filters</span></span>' +
					"</button>" +
				"</div>";
			enhanceButtons(results);
		}

		function renderArticles(items) {
			var isChronicles = section.classList.contains("s-journal-feed--chronicles");
			var isEjournals = section.classList.contains("s-journal-feed--ejournals");

			if (!items.length) {
				renderEmptyState();
				return;
			}

			if (isChronicles) {
				results.innerHTML = items.map(function (article) {
					var imageNote = article.variant === "image-note";
					var modalImage = escapeHtml(article.modalImage || article.image);
					var title = escapeHtml(article.title);
					var description = escapeHtml(article.description || "");
					var href = escapeHtml(article.href || "#");
					var image = escapeHtml(article.image);

					if (imageNote) {
						return (
							'<article class="b-article-card b-article-card--vertical b-article-card--image-note b-article-card--chronicles-feed">' +
								'<div class="b-article-card__media">' +
									'<button class="b-article-card__media-link anim-image" type="button" data-image-modal-toggle data-modal-image="' +
										modalImage +
										'" data-modal-title="' +
										title +
										'" data-modal-text="' +
										description +
										'" aria-label="Open image details">' +
										'<span class="anim-image__wrap">' +
											'<img class="anim-image__image" src="' +
												image +
												'" alt="' +
												title +
												'" loading="lazy">' +
										'</span>' +
									'</button>' +
									'<button class="b-article-card__media-action" type="button" data-image-modal-toggle data-modal-image="' +
										modalImage +
										'" data-modal-title="' +
										title +
										'" data-modal-text="' +
										description +
										'" aria-label="Open image details">' +
										'<svg aria-hidden="true"><use xlink:href="#icon-image-modal"></use></svg>' +
									"</button>" +
								"</div>" +
								'<div class="b-article-card__content">' +
									'<h3 data-image-modal-toggle data-modal-image="' +
										modalImage +
										'" data-modal-title="' +
										title +
										'" data-modal-text="' +
										description +
										'" role="button" tabindex="0">' +
										title +
									"</h3>" +
								"</div>" +
							"</article>"
						);
					}

					return (
						'<article class="b-article-card b-article-card--vertical b-article-card--chronicles-feed">' +
							'<div class="b-article-card__media">' +
								'<a class="b-article-card__media-link anim-image" href="' +
									href +
									'">' +
									'<span class="anim-image__wrap">' +
										'<img class="anim-image__image" src="' +
											image +
											'" alt="' +
											title +
											'" loading="lazy">' +
									'</span>' +
								"</a>" +
							"</div>" +
							'<div class="b-article-card__content">' +
								'<div class="b-article-card__copy">' +
									'<a href="' +
										href +
										'"><h3>' +
											title +
										"</h3></a>" +
									"<p>" +
										description +
									"</p>" +
								"</div>" +
								'<a class="b-link" href="' +
									href +
									'">Read Article</a>' +
							"</div>" +
						"</article>"
					);
				}).join("");
				return;
			}

			if (isEjournals) {
				results.innerHTML = items.map(function (article) {
					return (
						'<article class="b-article-card b-article-card--vertical b-article-card--ebook b-article-card--s-journal-feed--ejournals">' +
							'<div class="b-article-card__media">' +
								'<a class="b-article-card__media-link anim-image" href="' +
									escapeHtml(article.href) +
									'">' +
									'<span class="anim-image__wrap">' +
										'<img class="anim-image__image" src="' +
											escapeHtml(article.image) +
											'" alt="' +
											escapeHtml(article.title) +
											'" loading="lazy">' +
									'</span>' +
								"</a>" +
							"</div>" +
							'<div class="b-article-card__content">' +
								'<div class="b-article-card__copy">' +
									'<a href="' +
										escapeHtml(article.href) +
										'"><h3>' +
											escapeHtml(article.title) +
										"</h3></a>" +
									"<p>" +
										escapeHtml(article.description) +
									"</p>" +
								"</div>" +
								'<a class="b-link" href="' +
									escapeHtml(article.href) +
									'">Read Ebook</a>' +
							"</div>" +
						"</article>"
					);
				}).join("");
				return;
			}

			results.innerHTML = items.map(function (article) {
				return (
					'<article class="b-article-card b-article-card--vertical b-article-card--journal-feed">' +
						'<div class="b-article-card__media">' +
							'<a class="b-article-card__media-link anim-image" href="' +
								escapeHtml(article.href) +
								'">' +
								'<span class="anim-image__wrap">' +
									'<img class="anim-image__image" src="' +
										escapeHtml(article.image) +
										'" alt="' +
										escapeHtml(article.title) +
										'" loading="lazy">' +
								'</span>' +
							"</a>" +
						"</div>" +
						'<div class="b-article-card__content">' +
							'<span class="b-tag b-tag--bordered">' +
								escapeHtml(article.tag) +
							"</span>" +
							'<div class="b-article-card__copy">' +
								'<a href="' +
									escapeHtml(article.href) +
									'"><h3>' +
										escapeHtml(article.title) +
									"</h3></a>" +
								"<p>" +
									escapeHtml(article.description) +
								"</p>" +
							"</div>" +
						"</div>" +
					"</article>"
				);
			}).join("");
		}

		function renderFromData(data) {
			var filtered = filterArticles(data.articles || []);
			var itemsPerPage = getItemsPerPage();
			var totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));
			var start = 0;
			var end = 0;

			if (!pagination) {
				renderArticles(filtered);
			} else {
				if (state.page > totalPages) {
					state.page = totalPages;
				}

				start = (state.page - 1) * itemsPerPage;
				end = start + itemsPerPage;

				renderArticles(filtered.slice(start, end));
				renderPagination(pagination, state.page, totalPages);
			}

			requestSpinnerPosition();
			requestLenisResize();
		}

		function setLoading(nextState) {
			if (loadingTimer) {
				clearTimeout(loadingTimer);
				loadingTimer = null;
			}
			if (revealTimer) {
				clearTimeout(revealTimer);
				revealTimer = null;
			}

			if (nextState) {
				updateSpinnerPosition();
				spinnerLockedTop = resultsWrap.style.getPropertyValue("--journal-feed-spinner-top");
				section.classList.add("is-loading");
				section.classList.remove("is-results-pending");
				return;
			}

			section.classList.remove("is-loading");
			section.classList.add("is-results-pending");
			revealTimer = setTimeout(function () {
				spinnerLockedTop = "";
				section.classList.remove("is-results-pending");
				requestSpinnerPosition();
				revealTimer = null;
			}, 180);
		}

		function loadData(options) {
			var nextRequestId = requestId + 1;
			requestId = nextRequestId;

			if (options && options.resetPage) {
				state.page = 1;
			}

			setLoading(true);

			return Promise.all([
				fetch(source, { cache: "no-store" }).then(function (response) {
					if (!response.ok) {
						throw new Error("Failed to load journal feed data");
					}
					return response.json();
				}),
				new Promise(function (resolve) {
					setTimeout(resolve, 240);
				}),
			]).then(function (payload) {
				var data = payload[0];

				if (nextRequestId !== requestId) return;

				state.data = data;
				ensureFilters(data);
				renderFromData(data);
				updateGroupedParentStates();
				setLoading(false);
			}).catch(function () {
				if (nextRequestId !== requestId) return;
				results.innerHTML = '<p class="s-journal-feed__empty">Unable to load the journal archive right now.</p>';
				if (pagination) {
					pagination.hidden = true;
					pagination.innerHTML = "";
				}
				setLoading(false);
			});
		}

		section.addEventListener("change", function (event) {
			var input = event.target;
			var values;
			var config;

			if (!input.matches(".s-journal-feed__check-input")) return;

			config = filterConfigs.find(function (item) {
				return item.name === input.name;
			});
			if (!config) return;

			if (config.inputType === "radio") {
				state.filters[input.name] = input.value;
			} else {
				values = Array.from(
					section.querySelectorAll('.s-journal-feed__check-input[name="' + input.name + '"]:checked'),
				).map(function (item) {
					return item.value;
				});

				state.filters[input.name] = values;
			}

			updateGroupedParentStates();
			updateSimpleFilterCounts();
			loadData({ resetPage: true });
		});

		section.addEventListener("click", function (event) {
			var clearButton = event.target.closest("[data-journal-clear-filters]");
			var parentToggle = event.target.closest("[data-journal-parent-toggle]");
			var item;
			var filterName;
			var inputs;
			var shouldCheck;

			if (clearButton && section.contains(clearButton)) {
				event.preventDefault();
				resetFilters();

				if (state.data) {
					renderFromData(state.data);
					return;
				}

				loadData({ resetPage: true });
				return;
			}

			if (!parentToggle || !section.contains(parentToggle)) return;
			if (!section.querySelector("[data-journal-parent-filter]")) return;

			event.preventDefault();

			item = parentToggle.closest("[data-journal-parent-filter]");
			if (!item) return;

			filterName = item.getAttribute("data-journal-parent-filter");
			inputs = Array.from(item.querySelectorAll('.s-journal-feed__check-input[name="' + filterName + '"]'));
			if (!inputs.length) return;

			shouldCheck = !item.classList.contains("is-parent-checked");

			inputs.forEach(function (input) {
				input.checked = shouldCheck;
			});

			state.filters[filterName] = shouldCheck
				? inputs.map(function (input) {
						return input.value;
					})
				: [];

			updateGroupedParentStates();
			updateSimpleFilterCounts();
			loadData({ resetPage: true });
		});

		if (pagination) {
			pagination.addEventListener("click", function (event) {
				var target = event.target.closest("[data-journal-page], [data-journal-prev], [data-journal-next]");
				if (!target) return;

				if (target.hasAttribute("disabled")) return;

				if (target.hasAttribute("data-journal-prev")) {
					state.page = Math.max(1, state.page - 1);
				} else if (target.hasAttribute("data-journal-next")) {
					state.page += 1;
				} else {
					state.page = parseInt(target.getAttribute("data-journal-page"), 10) || 1;
				}

				loadData();
			});
		}

		window.addEventListener("resize", function () {
			if (resizeRaf) cancelAnimationFrame(resizeRaf);

			resizeRaf = requestAnimationFrame(function () {
				requestSpinnerPosition();
				resizeRaf = null;
			});
		});

		window.addEventListener("scroll", requestSpinnerPosition, { passive: true });

		requestSpinnerPosition();
		loadData();
	});
}

function initChronicleSliders() {
	document.querySelectorAll(".js-chronicles-slider").forEach(function (slider) {
		var section = slider.closest(".s-chronicles-feed");
		var prev = section ? section.querySelector("[data-chronicles-prev]") : null;
		var next = section ? section.querySelector("[data-chronicles-next]") : null;
		var slidesCount = slider.querySelectorAll(".swiper-slide").length;

		if (!slider) return;

		new Swiper(slider, {
			slidesPerView: "auto",
			spaceBetween: 0,
			watchOverflow: true,
			resizeObserver: false,
			loop: slidesCount > 1,
			loopedSlides: slidesCount,
			loopAdditionalSlides: slidesCount,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				1024: {
					allowTouchMove: false,
				},
			},
		});
	});
}

function initHeaderFeatureSliders() {
	document.querySelectorAll(".js-header-feature-slider").forEach(function (slider) {
		if (!slider) return;

		new Swiper(slider, {
			slidesPerView: "auto",
			spaceBetween: 1,
			watchOverflow: true,
			observer: false,
			observeParents: false,
			resizeObserver: false,
			breakpoints: {
				1024: {
					slidesPerView: 3,
					allowTouchMove: false,
				},
			},
		});
	});
}

function initProducerSliders() {
	document.querySelectorAll(".js-producers-slider").forEach(function (slider) {
		var section = slider.closest(".s-journal-producers");
		var prev = section ? section.querySelector("[data-producers-prev]") : null;
		var next = section ? section.querySelector("[data-producers-next]") : null;
		var slidesCount = slider.querySelectorAll(".swiper-slide").length;

		if (!slider) return;

		function updateProducerEdgeSlides(swiper) {
			var isDesktop = window.matchMedia("(min-width: 1024px)").matches;
			var slides = Array.from(swiper.slides || []);
			var visibleCount = 4;

			slides.forEach(function (slide) {
				slide.classList.remove("is-edge-fade");
			});

			if (!isDesktop) return;

			var leftEdge = swiper.activeIndex - 1;
			var rightEdge = swiper.activeIndex + visibleCount;

			if (slides[leftEdge]) {
				slides[leftEdge].classList.add("is-edge-fade");
			}

			if (slides[rightEdge]) {
				slides[rightEdge].classList.add("is-edge-fade");
			}
		}

		var swiper = new Swiper(slider, {
			loop: true,
			loopedSlides: slidesCount,
			loopAdditionalSlides: slidesCount,
			slidesPerView: "auto",
			spaceBetween: 1,
			watchOverflow: true,
			watchSlidesProgress: true,
			resizeObserver: false,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				1024: {
					slidesPerView: 4,
					allowTouchMove: false,
				},
			},
			on: {
				init: function (instance) {
					updateProducerEdgeSlides(instance);
				},
				slideChange: function (instance) {
					updateProducerEdgeSlides(instance);
				},
				breakpoint: function (instance) {
					updateProducerEdgeSlides(instance);
				},
				resize: function (instance) {
					updateProducerEdgeSlides(instance);
				},
			},
		});

		updateProducerEdgeSlides(swiper);
	});
}

function initLocalOfficePropertiesSlider() {
	document.querySelectorAll("[data-local-properties-slider]").forEach(function (slider) {
		var section = slider.closest(".s-local-office-properties");
		var prev = section ? section.querySelector("[data-local-properties-prev]") : null;
		var next = section ? section.querySelector("[data-local-properties-next]") : null;

		new Swiper(slider, {
			slidesPerView: 1.12,
			spaceBetween: 16,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		});
	});
}

function initKeyFeaturesSlider() {
	document.querySelectorAll("[data-key-features-slider]").forEach(function (slider) {
		var section = slider.closest(".s-key-features");
		var prev = section ? section.querySelector("[data-key-features-prev]") : null;
		var next = section ? section.querySelector("[data-key-features-next]") : null;

		new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 28,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 32,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
		});
	});
}

function initTextCarouselSlider() {
	document.querySelectorAll("[data-local-text-carousel-slider]").forEach(function (slider) {
		var section = slider.closest(".s-local-office-text-carousel");
		var prev = section ? section.querySelector("[data-local-text-carousel-prev]") : null;
		var next = section ? section.querySelector("[data-local-text-carousel-next]") : null;

		new Swiper(slider, {
			slidesPerView: 1.15,
			spaceBetween: 16,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				768: {
					slidesPerView: 2.15,
					spaceBetween: 20,
				},
				1280: {
					slidesPerView: 3.3,
					spaceBetween: 24,
				},
			},
		});
	});
}

function initLoTeamCarouselSlider() {
	document.querySelectorAll("[data-lo-team-carousel-slider]").forEach(function (slider) {
		var section = slider.closest(".s-lo-team-carousel");
		var prev = section ? section.querySelector("[data-lo-team-carousel-prev]") : null;
		var next = section ? section.querySelector("[data-lo-team-carousel-next]") : null;

		new Swiper(slider, {
			slidesPerView: "auto",
			spaceBetween: 24,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
		});
	});
}

function initLocalOfficeTeamSlider() {
	var mobileQuery = window.matchMedia("(max-width: 1279.98px)");

	document.querySelectorAll("[data-local-team-slider]").forEach(function (slider) {
		var section = slider.closest(".s-local-office-team");
		var prev = section ? section.querySelector("[data-local-team-prev]") : null;
		var next = section ? section.querySelector("[data-local-team-next]") : null;
		var instance = null;

		function createSlider() {
			if (instance || !mobileQuery.matches) return;

			instance = new Swiper(slider, {
				slidesPerView: "auto",
				spaceBetween: 20,
				speed: 700,
				watchOverflow: true,
				autoplay: {
					delay: 6000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			});
		}

		function destroySlider() {
			if (!instance) return;
			instance.destroy(true, true);
			instance = null;
		}

		function syncSlider() {
			if (mobileQuery.matches) {
				createSlider();
				return;
			}

			destroySlider();
		}

		syncSlider();

		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener("change", syncSlider);
		} else if (mobileQuery.addListener) {
			mobileQuery.addListener(syncSlider);
		}
	});
}

function initLocalOfficeTeamDesktopRotation() {
	var desktopQuery = window.matchMedia("(min-width: 1280px)");

	document.querySelectorAll(".s-local-office-team").forEach(function (section) {
		var cards = Array.from(
			section.querySelectorAll(
				".s-local-office-team__desktop-featured .b-team-card, .s-local-office-team__grid .b-team-card",
			),
		);
		var timerId = null;
		var isAnimating = false;
		var isRunning = false;
		var pool = [];

		if (!cards.length) return;

		function normalizeSrc(src) {
			try {
				return new URL(src, window.location.href).href;
			} catch (error) {
				return src;
			}
		}

		function getFileName(src) {
			var normalized = normalizeSrc(src || "");
			var clean = normalized.split("?")[0].split("#")[0];
			var parts = clean.split("/");

			return parts[parts.length - 1] || "";
		}

		function getPool() {
			var customPool = section.getAttribute("data-local-team-rotation-pool");

			if (customPool) {
				return customPool
					.split(",")
					.map(function (item) {
						return item.trim();
					})
					.filter(Boolean);
			}

			return Array.from(
				new Set(
					cards
						.map(function (card) {
							var image = card.querySelector("img[data-parallax-target], img");
							return image ? image.getAttribute("src") : "";
						})
						.filter(Boolean),
				),
			);
		}

		function clearTimer() {
			if (!timerId) return;
			clearTimeout(timerId);
			timerId = null;
		}

		function ensureLayerState(card) {
			var base = card.querySelector("img[data-parallax-target]:not(.b-team-card__swap-image), img:not(.b-team-card__swap-image)");
			var overlay;

			if (!base) return null;

			overlay = card.querySelector(".b-team-card__swap-image");

			if (!overlay) {
				overlay = base.cloneNode(false);
				overlay.className = "b-team-card__swap-image";
				overlay.setAttribute("data-parallax-target", "");
				overlay.src = base.getAttribute("src") || "";
				overlay.alt = base.getAttribute("alt") || "";
				card.appendChild(overlay);
			}

			return {
				base: base,
				overlay: overlay,
			};
		}

		function cleanupOverlays() {
			cards.forEach(function (card) {
				var state = ensureLayerState(card);
				if (!state) return;

				state.overlay.classList.remove("is-visible");
				state.overlay.src = state.base.getAttribute("src") || "";
				state.overlay.alt = state.base.getAttribute("alt") || "";
			});
		}

		function scheduleNext() {
			if (!isRunning) return;

			clearTimer();
			timerId = setTimeout(runNextSwap, 1000 + Math.random() * 900);
		}

		function finishSwap(state, nextSrc) {
			state.base.setAttribute("src", nextSrc);
			state.base.setAttribute("alt", state.overlay.getAttribute("alt") || "");

			requestAnimationFrame(function () {
				state.overlay.classList.remove("is-visible");
				isAnimating = false;
				scheduleNext();
			});
		}

		function startSwap(state, nextSrc) {
			var currentOffset = state.base.style.getPropertyValue("--parallax-offset") || "0px";

			isAnimating = true;
			state.overlay.classList.remove("is-visible");
			state.overlay.src = nextSrc;
			state.overlay.alt = state.base.getAttribute("alt") || "";
			state.overlay.style.setProperty("--parallax-offset", currentOffset);

			state.overlay.getBoundingClientRect();

			requestAnimationFrame(function () {
				state.overlay.classList.add("is-visible");
			});

			setTimeout(function () {
				finishSwap(state, nextSrc);
			}, 700);
		}

		function getVisibleFileName(card) {
			var state = ensureLayerState(card);
			var image;

			if (!state) return "";

			image = state.overlay.classList.contains("is-visible") ? state.overlay : state.base;

			return getFileName(image.getAttribute("src") || image.currentSrc || "");
		}

		function runNextSwap() {
			var card;
			var state;
			var image;
			var currentSrc;
			var shownElsewhere;
			var candidates;
			var nextSrc;
			var preload;

			if (!isRunning || isAnimating) return;

			card = cards[Math.floor(Math.random() * cards.length)];
			state = card ? ensureLayerState(card) : null;
			image = state ? state.base : null;
			if (!image) {
				scheduleNext();
				return;
			}

			currentSrc = normalizeSrc(image.getAttribute("src") || image.currentSrc || "");

			// Never swap in a photo that's already showing on another card —
			// only the current card's own filename is exempt (it's what we're
			// replacing), everyone else's currently-visible photo is off-limits.
			shownElsewhere = new Set();
			cards.forEach(function (otherCard) {
				if (otherCard === card) return;
				var fileName = getVisibleFileName(otherCard);
				if (fileName) shownElsewhere.add(fileName);
			});

			candidates = pool.filter(function (src) {
				var fileName = getFileName(src);
				return fileName !== getFileName(currentSrc) && !shownElsewhere.has(fileName);
			});

			if (!candidates.length) {
				scheduleNext();
				return;
			}

			nextSrc = candidates[Math.floor(Math.random() * candidates.length)];
			preload = new Image();
			preload.onload = function () {
				if (!isRunning) return;
				startSwap(state, nextSrc);
			};
			preload.onerror = function () {
				isAnimating = false;
				scheduleNext();
			};
			preload.src = nextSrc;
		}

		function start() {
			pool = getPool();
			if (pool.length < 2) return;
			if (isRunning) return;

			isRunning = true;
			scheduleNext();
		}

		function stop() {
			isRunning = false;
			isAnimating = false;
			clearTimer();
			cleanupOverlays();
		}

		function syncState() {
			if (desktopQuery.matches) {
				start();
				return;
			}

			stop();
		}

		syncState();

		if (desktopQuery.addEventListener) {
			desktopQuery.addEventListener("change", syncState);
		} else if (desktopQuery.addListener) {
			desktopQuery.addListener(syncState);
		}
	});
}

function initLocalOfficeNewsFeaturedSlider() {
	document.querySelectorAll("[data-local-office-news-featured-slider]").forEach(function (slider) {
		var section = slider.closest(".s-local-office-news-featured");
		var prevButtons = section ? Array.from(section.querySelectorAll("[data-local-office-news-featured-prev]")) : [];
		var nextButtons = section ? Array.from(section.querySelectorAll("[data-local-office-news-featured-next]")) : [];

		function getVisibleButton(buttons) {
			return buttons.find(function (button) {
				return button.offsetParent !== null;
			}) || buttons[0] || null;
		}

		var prev = getVisibleButton(prevButtons);
		var next = getVisibleButton(nextButtons);

		new Swiper(slider, {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 40,
			speed: 700,
			watchOverflow: true,
			allowTouchMove: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
		});
	});
}

function initLocalOfficeAboutNewsSlider() {
	document.querySelectorAll("[data-local-office-about-news-slider]").forEach(function (slider) {
		var section = slider.closest(".s-local-office-about-news");
		var prevButtons = section ? Array.from(section.querySelectorAll("[data-local-office-about-news-prev]")) : [];
		var nextButtons = section ? Array.from(section.querySelectorAll("[data-local-office-about-news-next]")) : [];

		function getVisibleButton(buttons) {
			return buttons.find(function (button) {
				return button.offsetParent !== null;
			}) || buttons[0] || null;
		}

		var prev = getVisibleButton(prevButtons);
		var next = getVisibleButton(nextButtons);

		new Swiper(slider, {
			slidesPerView: 1.3,
			spaceBetween: 20,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		});
	});
}

function initNewsArticleLatestSlider() {
	document.querySelectorAll("[data-news-article-latest-slider]").forEach(function (slider) {
		var section = slider.closest(".s-local-office-news-article-latest");
		var prevButtons = section ? Array.from(section.querySelectorAll("[data-news-article-latest-prev]")) : [];
		var nextButtons = section ? Array.from(section.querySelectorAll("[data-news-article-latest-next]")) : [];

		function getVisibleButton(buttons) {
			return buttons.find(function (button) {
				return button.offsetParent !== null;
			}) || buttons[0] || null;
		}

		var prev = getVisibleButton(prevButtons);
		var next = getVisibleButton(nextButtons);

		new Swiper(slider, {
			slidesPerView: "auto",
			spaceBetween: 20,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
		});
	});
}

function initContributorsList() {
	var items = Array.from(document.querySelectorAll("[data-contributor-item]"));

	if (!items.length) return;

	function isMobileView() {
		return window.matchMedia("(max-width: 767.98px)").matches;
	}

	function getCollapsedHeight(body) {
		var lineHeight = parseFloat(window.getComputedStyle(body).lineHeight) || 18;
		return Math.round(lineHeight * 5);
	}

	function setState(item, isOpen, skipAnimation) {
		var body = item.querySelector("[data-contributor-body]");
		var collapsedHeight;

		if (!body) return;

		if (!isMobileView()) {
			item.classList.remove("is-open");
			body.style.maxHeight = "";
			return;
		}

		collapsedHeight = getCollapsedHeight(body);
		item.classList.toggle("is-open", isOpen);

		if (skipAnimation) {
			body.style.maxHeight = (isOpen ? body.scrollHeight : collapsedHeight) + "px";
			return;
		}

		if (isOpen) {
			body.style.maxHeight = collapsedHeight + "px";
			body.offsetHeight;
			body.style.maxHeight = body.scrollHeight + "px";
			return;
		}

		body.style.maxHeight = body.scrollHeight + "px";
		body.offsetHeight;
		body.style.maxHeight = collapsedHeight + "px";
	}

	function syncLabels() {
		var isMobile = isMobileView();

		items.forEach(function (item) {
			var toggle = item.querySelector("[data-contributor-toggle]");
			var label = item.querySelector(".s-contributors-list__toggle-label");
			var isOpen = item.classList.contains("is-open");

			if (!toggle || !label) return;

			if (!isMobile) {
				toggle.setAttribute("aria-expanded", "true");
				label.textContent = "Read Less";
				return;
			}

			toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
			label.textContent = isOpen ? "Read Less" : "Read More";
		});
	}

	document.addEventListener("click", function (event) {
		var toggle = event.target.closest("[data-contributor-toggle]");
		var item;

		if (!toggle) return;

		item = toggle.closest("[data-contributor-item]");
		if (!item) return;
		if (!isMobileView()) return;

		setState(item, !item.classList.contains("is-open"), false);
		syncLabels();
	});

	window.addEventListener("resize", function () {
		items.forEach(function (item) {
			setState(item, item.classList.contains("is-open"), true);
		});
		syncLabels();
	});

	items.forEach(function (item) {
		setState(item, item.classList.contains("is-open"), true);
	});
	syncLabels();
}

function createButtonTextTrack(text) {
	var fragment = document.createDocumentFragment();
	var track = document.createElement("span");

	text.split("").forEach(function (character, index) {
		var slot = document.createElement("span");
		var symbol = document.createElement("span");

		slot.className = "btn__char-slot";
		symbol.className = "btn__char";
		symbol.style.setProperty("--char-index", index);
		symbol.textContent = character === " " ? "\u00A0" : character;
		slot.appendChild(symbol);
		fragment.appendChild(slot);
	});

	track.className = "btn__text-track";
	track.appendChild(fragment);

	return track;
}

function enhanceButtons(root) {
	return root;
}

function syncHomeHeroCopyPosition(inner, geometry) {
	var innerRect;
	var copyTop;
	var copyLeft;

	if (!inner || !geometry) return;

	innerRect = inner.getBoundingClientRect();
	copyTop = (geometry.y + geometry.height + 52) - innerRect.top;
	copyLeft = geometry.x - innerRect.left;

	inner.style.setProperty("--home-copy-top", copyTop.toFixed(2) + "px");
	inner.style.setProperty("--home-copy-left", copyLeft.toFixed(2) + "px");
}

var homeHeroMobileViewport = null;

function getHomeHeroViewport(mobileQuery) {
	if (!mobileQuery.matches) {
		homeHeroMobileViewport = null;
		return {
			width: window.innerWidth,
			height: window.innerHeight,
		};
	}

	if (!homeHeroMobileViewport) {
		homeHeroMobileViewport = {
			width: window.innerWidth,
			height: window.innerHeight,
		};
	}

	return homeHeroMobileViewport;
}

function getHomeHeroMaskGeometry(progress, mobileQuery) {
	var logoViewBox = {
		width: 1359.802991,
		height: 259.502496,
	};
	var gTarget = {
		x: 716,
		y: 151,
		height: 18,
	};
	var viewport = getHomeHeroViewport(mobileQuery);
	var eased = progress * progress * (3 - (2 * progress));
	var viewportWidth = viewport.width;
	var viewportHeight = viewport.height;
	var logoAspect = logoViewBox.height / logoViewBox.width;
	var startMaskWidth = viewportWidth * (mobileQuery.matches ? 0.91 : 0.94);
	var startMaskHeight = startMaskWidth * logoAspect;
	var endMaskWidth = (viewportHeight * logoViewBox.width) / gTarget.height;
	var endMaskHeight = endMaskWidth * logoAspect;
	var maskWidth = startMaskWidth + ((endMaskWidth - startMaskWidth) * eased);
	var startPositionX = (viewportWidth - startMaskWidth) / 2;
	var startPositionY = (viewportHeight - startMaskHeight) / 2;
	var targetPositionX = (viewportWidth / 2) - ((gTarget.x / logoViewBox.width) * endMaskWidth);
	var targetPositionY = (viewportHeight / 2) - ((gTarget.y / logoViewBox.height) * endMaskHeight);
	var maskX = startPositionX + ((targetPositionX - startPositionX) * eased);
	var maskY = startPositionY + ((targetPositionY - startPositionY) * eased);

	return {
		x: maskX,
		y: maskY,
		width: maskWidth,
		height: maskWidth * logoAspect,
		size: maskWidth.toFixed(2) + "px",
		position: maskX.toFixed(2) + "px " + maskY.toFixed(2) + "px",
	};
}

function initHomeHeroAnimation() {
	var hero = document.querySelector("[data-home-hero]");
	var heroInner = hero ? hero.querySelector(".s-home-hero__sticky .s-home-hero__inner") : null;
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");
	var lastViewportWidth = window.innerWidth;
	var ticking = false;

	if (!hero) return;

	function updateCopyPosition() {
		if (!heroInner) return;

		syncHomeHeroCopyPosition(heroInner, getHomeHeroMaskGeometry(0, mobileQuery));
	}

	function update() {
		var rect = hero.getBoundingClientRect();
		var viewport = getHomeHeroViewport(mobileQuery);
		var sensitivity = mobileQuery.matches ? 1.5 : 1.0;
		var scrollable = Math.max((rect.height - viewport.height) * sensitivity, 1);
		var progress = Math.min(Math.max(-rect.top / scrollable, 0), 1);
		var mask = getHomeHeroMaskGeometry(progress, mobileQuery);
		var copyOpacity = Math.max(1 - (progress * 2.5), 0);

		hero.style.setProperty("--hero-mask-size", mask.size);
		hero.style.setProperty("--hero-mask-position", mask.position);
		hero.style.setProperty("--hero-copy-opacity", copyOpacity.toFixed(4));
		ticking = false;
	}

	function requestUpdate() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}

	window.addEventListener("scroll", requestUpdate, { passive: true });
	window.addEventListener("resize", function () {
		var widthChanged = Math.abs(window.innerWidth - lastViewportWidth) > 4;

		if (!mobileQuery.matches || widthChanged) {
			homeHeroMobileViewport = mobileQuery.matches
				? {
					width: window.innerWidth,
					height: window.innerHeight,
				}
				: null;
			updateCopyPosition();
		}

		lastViewportWidth = window.innerWidth;
		requestUpdate();
	});
	updateCopyPosition();
	update();
}

function initHomePreloader() {
	var preloader = document.querySelector("[data-home-preloader]");
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");
	var preloaderFill;
	var preloaderVideo;
	var heroVideo;
	var hasStarted = false;
	var hasFinished = false;
	var previousScrollRestoration = null;
	var scrollLockKeys = ["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "End", "Home", "PageDown", "PageUp", " "];

	if (!preloader) return;

	preloaderFill = preloader.querySelector(".b-home-preloader__fill");
	preloaderVideo = preloader.querySelector("[data-preloader-video]");
	heroVideo = document.querySelector("[data-home-hero-video]");
	document.body.classList.add("is-home-preloading");

	if ("scrollRestoration" in window.history) {
		previousScrollRestoration = window.history.scrollRestoration;
		window.history.scrollRestoration = "manual";
	}

	function forceHomeTop() {
		if (window.lenis && typeof window.lenis.scrollTo === "function") {
			window.lenis.scrollTo(0, {
				immediate: true,
				force: true,
			});
		}

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
		window.scrollTo(0, 0);
	}

	function preventPreloaderScroll(event) {
		if (!document.body.classList.contains("is-home-preloading")) return;

		event.preventDefault();
		forceHomeTop();
	}

	function preventPreloaderKeyScroll(event) {
		if (scrollLockKeys.indexOf(event.key) === -1) return;

		preventPreloaderScroll(event);
	}

	function keepPreloaderAtTop() {
		if (!document.body.classList.contains("is-home-preloading")) return;

		window.requestAnimationFrame(forceHomeTop);
	}

	forceHomeTop();
	window.requestAnimationFrame(forceHomeTop);
	window.setTimeout(forceHomeTop, 80);
	window.setTimeout(forceHomeTop, 280);
	window.addEventListener("wheel", preventPreloaderScroll, { passive: false });
	window.addEventListener("touchmove", preventPreloaderScroll, { passive: false });
	window.addEventListener("keydown", preventPreloaderKeyScroll);
	window.addEventListener("scroll", keepPreloaderAtTop, { passive: true });

	function setInitialMask() {
		var mask = getHomeHeroMaskGeometry(0, mobileQuery);

		preloader.style.setProperty("--preloader-mask-size", mask.size);
		preloader.style.setProperty("--preloader-mask-position", mask.position);
	}

	function syncHeroVideo() {
		if (!preloaderVideo || !heroVideo) return;

		try {
			if (!Number.isNaN(preloaderVideo.currentTime)) {
				heroVideo.currentTime = preloaderVideo.currentTime;
			}
			if (typeof heroVideo.play === "function") {
				heroVideo.play().catch(function () {});
			}
		} catch (e) {
			// Video sync is best-effort only.
		}
	}

	function finish() {
		if (hasFinished) return;
		hasFinished = true;

		syncHeroVideo();
		forceHomeTop();
		preloader.classList.add("is-finished");
		document.body.classList.remove("is-home-preloading");
		window.removeEventListener("wheel", preventPreloaderScroll);
		window.removeEventListener("touchmove", preventPreloaderScroll);
		window.removeEventListener("keydown", preventPreloaderKeyScroll);
		window.removeEventListener("scroll", keepPreloaderAtTop);

		if (window.lenis && typeof window.lenis.start === "function") {
			window.lenis.start();
		}

		if (previousScrollRestoration) {
			window.history.scrollRestoration = previousScrollRestoration;
		}

		window.setTimeout(function () {
			if (preloader.parentNode) {
				preloader.parentNode.removeChild(preloader);
			}
		}, 650);
	}

	function start() {
		if (hasStarted) return;
		hasStarted = true;
		forceHomeTop();

		if (window.lenis && typeof window.lenis.stop === "function") {
			window.lenis.stop();
		}

		window.setTimeout(function () {
			preloader.classList.add("is-media");
		}, 180);

		if (preloaderFill) {
			preloaderFill.addEventListener("transitionend", function (event) {
				if (event.propertyName !== "transform") return;

				finish();
			}, { once: true });
		}

		window.setTimeout(finish, 2400);
	}

	setInitialMask();
	window.addEventListener("resize", setInitialMask);

	if (document.readyState === "complete") {
		window.setTimeout(start, 220);
	} else {
		window.addEventListener("load", function () {
			window.setTimeout(start, 220);
		}, { once: true });
		window.setTimeout(start, 3600);
	}
}

function initHomeFilters() {
	var groups = Array.from(document.querySelectorAll("[data-home-filters]"));

	groups.forEach(function (group) {
		var section = group.closest(".s-property-search");
		var thumbs = section ? Array.from(section.querySelectorAll("[data-thumb-state]")) : [];

		group.addEventListener("click", function (event) {
			var filter = event.target.closest(".s-property-search__filter");
			var state;

			if (!filter || !group.contains(filter)) return;

			state = filter.getAttribute("data-filter-state");

			Array.from(group.querySelectorAll(".s-property-search__filter")).forEach(function (item) {
				var isActive = item === filter;

				item.classList.toggle("is-active", isActive);
				item.setAttribute("aria-pressed", isActive ? "true" : "false");
			});

			if (!state || !thumbs.length) return;

			thumbs.forEach(function (thumb) {
				thumb.classList.toggle("is-active", thumb.getAttribute("data-thumb-state") === state);
			});
		});
	});
}

function initHomeAutocomplete() {
	var forms = Array.from(document.querySelectorAll("[data-location-autocomplete]"));
	var suggestions = [
		"Adelaide CBD",
		"North Adelaide",
		"Port Adelaide",
		"Norwood",
		"Unley",
		"Brisbane CBD",
		"Darwin City",
		"Melbourne CBD",
		"Perth CBD",
	];

	forms.forEach(function (form) {
		var autocomplete = form.querySelector("[data-autocomplete-root]") || form.querySelector(".s-property-search__autocomplete");
		var input = form.querySelector("[data-location-input]");
		var list = form.querySelector("[data-location-suggestions]");
		var pills = form.querySelector("[data-location-pills]");
		var selected = [];

		if (!autocomplete || !input || !list || !pills) return;

		function getSuggestionClass() {
			return autocomplete.classList.contains("header__search-autocomplete")
				? "header__search-suggestion"
				: "s-property-search__suggestion";
		}

		function getPillClass() {
			return autocomplete.classList.contains("header__search-autocomplete")
				? "header__search-pill"
				: "s-property-search__pill";
		}

		function getPillRemoveClass() {
			return autocomplete.classList.contains("header__search-autocomplete")
				? "header__search-pill-remove"
				: "s-property-search__pill-remove";
		}

		function getPillIconClass() {
			return autocomplete.classList.contains("header__search-autocomplete")
				? "header__search-pill-icon"
				: "s-property-search__pill-icon";
		}

		function openList() {
			autocomplete.classList.add("is-open");
			list.removeAttribute("inert");
		}

		function closeList() {
			autocomplete.classList.remove("is-open");
			list.setAttribute("inert", "");
		}

		function syncList() {
			var query = input.value.trim().toLowerCase();
			var matches = suggestions.filter(function (item) {
				return item.toLowerCase().indexOf(query) !== -1 && selected.indexOf(item) === -1;
			}).slice(0, 5);

			list.textContent = "";

			if (!query || !matches.length) {
				closeList();
				return;
			}

			matches.forEach(function (item) {
				var row = document.createElement("li");
				var button = document.createElement("button");

				button.type = "button";
				button.className = getSuggestionClass();
				button.textContent = item;
				button.setAttribute("data-location-suggestion", item);
				row.appendChild(button);
				list.appendChild(row);
			});

			openList();
		}

		function renderPills() {
			pills.textContent = "";

			selected.forEach(function (item) {
				var pill = document.createElement("span");
				var remove = document.createElement("button");

				pill.className = getPillClass();
				pill.textContent = item;

				remove.type = "button";
				remove.className = getPillRemoveClass();
				remove.setAttribute("aria-label", "Remove " + item);
				remove.setAttribute("data-location-remove", item);
				remove.innerHTML = '<svg class="' + getPillIconClass() + '" aria-hidden="true"><use xlink:href="#icon-close-small"></use></svg>';

				pill.appendChild(remove);
				pills.appendChild(pill);
			});
		}

		function addLocation(value) {
			if (!value || selected.indexOf(value) !== -1) return;

			selected.push(value);
			input.value = "";
			renderPills();
			syncList();
			input.focus();
		}

		form.addEventListener("submit", function (event) {
			event.preventDefault();
		});

		input.addEventListener("input", syncList);
		input.addEventListener("focus", syncList);
		input.addEventListener("keydown", function (event) {
			var firstSuggestion;

			if (event.key !== "Enter" || !autocomplete.classList.contains("is-open")) return;

			firstSuggestion = list.querySelector("[data-location-suggestion]");
			if (!firstSuggestion) return;

			event.preventDefault();
			addLocation(firstSuggestion.getAttribute("data-location-suggestion"));
		});

		list.addEventListener("click", function (event) {
			var suggestion = event.target.closest("[data-location-suggestion]");

			if (!suggestion) return;
			addLocation(suggestion.getAttribute("data-location-suggestion"));
		});

		pills.addEventListener("click", function (event) {
			var remove = event.target.closest("[data-location-remove]");
			var value;

			if (!remove) return;

			value = remove.getAttribute("data-location-remove");
			selected = selected.filter(function (item) {
				return item !== value;
			});
			renderPills();
			syncList();
		});

		document.addEventListener("click", function (event) {
			if (form.contains(event.target)) return;
			closeList();
		});
	});
}

function initResponsivePlaceholders() {
	var fields = Array.from(document.querySelectorAll("[data-placeholder-desktop][data-placeholder-mobile]"));
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");

	if (!fields.length) return;

	function syncField(field) {
		field.setAttribute(
			"placeholder",
			mobileQuery.matches
				? field.getAttribute("data-placeholder-mobile")
				: field.getAttribute("data-placeholder-desktop"),
		);
	}

	function syncAll() {
		fields.forEach(syncField);
	}

	if (mobileQuery.addEventListener) {
		mobileQuery.addEventListener("change", syncAll);
	} else if (mobileQuery.addListener) {
		mobileQuery.addListener(syncAll);
	}

	syncAll();
}

function initPropertyDropdowns() {
	var selects = Array.from(document.querySelectorAll("[data-b-select]"));
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");

	if (!selects.length) return;

	function isMobileAccordion(select) {
		return mobileQuery.matches && select.classList.contains("b-select--mobile-accordion");
	}

	function syncSelectControls(select, isDisabled) {
		select.querySelectorAll("[data-select-check-all], [data-select-checkbox]").forEach(function (control) {
			control.disabled = isDisabled;
		});
	}

	function updateDropdownHeight(select) {
		var dropdown = select.querySelector("[data-select-dropdown]");
		var inner = select.querySelector(".b-select__dropdown-inner");
		var content;
		var height;

		if (!dropdown) return;
		content = dropdown.querySelector(".b-select__list, .b-select__fieldset");
		height = content ? content.offsetHeight : inner ? inner.scrollHeight : dropdown.scrollHeight;

		select.style.setProperty("--select-dropdown-height", height + "px");
	}

	function closeSelect(select) {
		var trigger = select.querySelector("[data-select-trigger]");
		var dropdown = select.querySelector("[data-select-dropdown]");

		select.classList.remove("is-open");

		if (trigger) {
			trigger.setAttribute("aria-expanded", "false");
		}

		if (dropdown) {
			dropdown.setAttribute("inert", "");
		}

		syncSelectControls(select, true);
	}

	function closeOthers(activeSelect) {
		selects.forEach(function (select) {
			if (select !== activeSelect) {
				closeSelect(select);
			}
		});
	}

	function openSelect(select) {
		var trigger = select.querySelector("[data-select-trigger]");
		var dropdown = select.querySelector("[data-select-dropdown]");
		var firstOption = select.querySelector("[data-select-option], [data-select-checkbox]");

		if (!trigger || !dropdown) return;

		updateDropdownHeight(select);
		closeOthers(select);
		select.classList.add("is-open");
		trigger.setAttribute("aria-expanded", "true");
		dropdown.removeAttribute("inert");
		syncSelectControls(select, false);

		if (firstOption) {
			window.setTimeout(function () {
				firstOption.focus();
			}, 0);
		}
	}

	function toggleSelect(select) {
		if (select.classList.contains("is-open")) {
			closeSelect(select);
			return;
		}

		openSelect(select);
	}

	function updateTriggerIcon(select, hasValue) {
		var iconUse = select.querySelector(".b-select__trigger-icon use");

		if (!iconUse) return;

		iconUse.setAttribute("xlink:href", hasValue ? "#icon-cross" : "#icon-select-arrow");
		iconUse.setAttribute("href", hasValue ? "#icon-cross" : "#icon-select-arrow");
	}

	function updateMultipleValue(select) {
		var valueNode = select.querySelector("[data-select-value]");
		var checkAll = select.querySelector("[data-select-check-all]");
		var checkboxes = Array.from(select.querySelectorAll("[data-select-checkbox]"));
		var checked = Array.from(select.querySelectorAll("[data-select-checkbox]:checked"));
		var labels = checked.map(function (checkbox) {
			var label = checkbox.closest(".b-select__checkbox");

			return label ? label.textContent.trim() : checkbox.value;
		});

		if (!valueNode) return;

		if (checkAll) {
			checkAll.textContent = checked.length === checkboxes.length && checkboxes.length ? "Uncheck all" : "Check all";
		}

		if (!labels.length) {
			valueNode.textContent = "Property Type";
			select.classList.remove("has-value");
			updateTriggerIcon(select, false);
			return;
		}

		valueNode.textContent = labels.join(", ");
		select.classList.add("has-value");
		updateTriggerIcon(select, true);
	}

	selects.forEach(function (select) {
		var dropdown = select.querySelector("[data-select-dropdown]");
		var trigger = select.querySelector("[data-select-trigger]");
		var valueNode = select.querySelector("[data-select-value]");
		var hiddenInput = select.querySelector("[data-select-input]");
		var options = Array.from(select.querySelectorAll("[data-select-option]"));
		var checkboxes = Array.from(select.querySelectorAll("[data-select-checkbox]"));
		var checkAll = select.querySelector("[data-select-check-all]");
		var selectType = select.getAttribute("data-select-type");

		if (!trigger || !valueNode) return;

		var defaultValueHTML = valueNode.innerHTML;
		var defaultInputValue = hiddenInput ? hiddenInput.value : "";
		var floatingLabel = document.createElement("span");

		floatingLabel.className = "b-select__floating-label";
		floatingLabel.setAttribute("aria-hidden", "true");
		floatingLabel.innerHTML = defaultValueHTML;
		trigger.insertBefore(floatingLabel, trigger.firstChild);

		if (dropdown) {
			dropdown.setAttribute("data-lenis-prevent", "");
			dropdown.setAttribute("data-lenis-prevent-wheel", "");
			dropdown.setAttribute("data-lenis-prevent-touch", "");
		}

		function resetSelect() {
			if (hiddenInput) {
				hiddenInput.value = defaultInputValue;
			}

			options.forEach(function (option) {
				option.setAttribute("aria-selected", "false");
			});

			if (checkboxes.length) {
				checkboxes.forEach(function (checkbox) {
					checkbox.checked = false;
				});
				updateMultipleValue(select);
			} else {
				valueNode.innerHTML = defaultValueHTML;
				select.classList.remove("has-value");
				updateTriggerIcon(select, false);
			}

			closeSelect(select);
			updateDropdownHeight(select);
		}

		trigger.addEventListener("click", function (event) {
			if (select.classList.contains("has-value") && event.target.closest(".b-select__trigger-icon")) {
				event.preventDefault();
				event.stopPropagation();
				resetSelect();
				return;
			}

			toggleSelect(select);
		});

		trigger.addEventListener("keydown", function (event) {
			if (event.key !== "Enter" && event.key !== " ") return;

			event.preventDefault();
			toggleSelect(select);
		});

		options.forEach(function (option) {
			option.addEventListener("click", function () {
				var value = option.getAttribute("data-value") || option.textContent.trim();

				valueNode.textContent = option.textContent.trim();
				select.classList.add("has-value");
				updateTriggerIcon(select, true);

				if (hiddenInput) {
					hiddenInput.value = value;
				}

				options.forEach(function (item) {
					item.setAttribute("aria-selected", item === option ? "true" : "false");
				});

				if (selectType === "single") {
					closeSelect(select);
					trigger.focus();
				}
			});

			option.addEventListener("keydown", function (event) {
				if (event.key === "Escape") {
					event.preventDefault();
					closeSelect(select);
					trigger.focus();
					return;
				}

				if (event.key !== "Enter" && event.key !== " ") return;

				event.preventDefault();
				option.click();
			});
		});

		checkboxes.forEach(function (checkbox) {
			checkbox.addEventListener("change", function () {
				updateMultipleValue(select);
			});

			checkbox.addEventListener("keydown", function (event) {
				if (event.key !== "Escape") return;

				event.preventDefault();
				closeSelect(select);
				trigger.focus();
			});
		});

		if (checkAll) {
			checkAll.addEventListener("click", function () {
				var shouldCheck = checkboxes.some(function (checkbox) {
					return !checkbox.checked;
				});

				checkboxes.forEach(function (checkbox) {
					checkbox.checked = shouldCheck;
				});
				updateMultipleValue(select);
				updateDropdownHeight(select);
			});
			updateMultipleValue(select);
		}

		updateDropdownHeight(select);
		closeSelect(select);
	});

	window.addEventListener("resize", function () {
		selects.forEach(updateDropdownHeight);
	});

	document.addEventListener("click", function (event) {
		selects.forEach(function (select) {
			if (isMobileAccordion(select)) return;
			if (select.contains(event.target)) return;

			closeSelect(select);
		});
	});

	document.addEventListener("keydown", function (event) {
		if (event.key !== "Escape") return;

		selects.forEach(closeSelect);
	});
}

function initParallaxMedia() {
	var triggers = Array.from(document.querySelectorAll('[data-parallax="trigger"]'));
	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
	var ticking = false;

	if (!triggers.length) return;

	function setOffset(trigger, value) {
		var targets = Array.from(trigger.querySelectorAll("[data-parallax-target]"));

		if (!targets.length) return;
		targets.forEach(function (target) {
			target.style.setProperty("--parallax-offset", value.toFixed(2) + "px");
		});
	}

	function update() {
		var viewportHeight = window.innerHeight;

		triggers.forEach(function (trigger) {
			var rect = trigger.getBoundingClientRect();
			var start = parseFloat(trigger.getAttribute("data-parallax-start"));
			var end = parseFloat(trigger.getAttribute("data-parallax-end"));
			var progress;
			var offset;

			if (Number.isNaN(start)) start = 20;
			if (Number.isNaN(end)) end = -20;

			if (reduceMotion.matches) {
				setOffset(trigger, 0);
				return;
			}

			progress = (viewportHeight - rect.top) / Math.max(viewportHeight + rect.height, 1);
			progress = Math.min(Math.max(progress, 0), 1);
			offset = start + ((end - start) * progress);

			setOffset(trigger, offset);
		});

		ticking = false;
	}

	function requestUpdate() {
		if (ticking) return;

		ticking = true;
		requestAnimationFrame(update);
	}

	window.addEventListener("scroll", requestUpdate, { passive: true });
	window.addEventListener("resize", requestUpdate);

	if (reduceMotion.addEventListener) {
		reduceMotion.addEventListener("change", requestUpdate);
	} else if (reduceMotion.addListener) {
		reduceMotion.addListener(requestUpdate);
	}

	update();
}

function initAnimatedFeaturesList() {
	var items = Array.from(document.querySelectorAll("[data-animated-list-item]"));
	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");
	var triggers = [];

	if (!items.length) return;

	function teardownScrollEffect() {
		triggers.forEach(function (trigger) {
			trigger.kill();
		});
		triggers = [];

		items.forEach(function (item) {
			var wrapper = item.querySelector("[data-animated-list-image-wrapper]");
			var heading = item.querySelector("[data-animated-list-heading]");

			if (wrapper) gsap.set(wrapper, { clearProps: "width,marginRight" });
			if (heading) gsap.set(heading, { clearProps: "opacity" });
		});
	}

	// Mobile shows the expanded state statically (no horizontal scroll-scrub —
	// the effect only reads well with room either side of the frame), and
	// reduced-motion users skip straight to the end state everywhere.
	function useStaticState() {
		teardownScrollEffect();
		items.forEach(function (item) {
			item.classList.add("is-expanded");
		});
	}

	// Expanded width/gap are read from --animated-list-image-width /
	// --animated-list-image-gap (set per breakpoint tier in animated-list.scss)
	// rather than hardcoded, so the scrub target always matches the current
	// viewport's sizing instead of overflowing on tablet-width windows.
	function useScrollEffect() {
		items.forEach(function (item) {
			item.classList.remove("is-expanded");

			var wrapper = item.querySelector("[data-animated-list-image-wrapper]");
			var heading = item.querySelector("[data-animated-list-heading]");

			if (!wrapper || !heading) return;

			var styles = getComputedStyle(wrapper);
			var targetWidth = styles.getPropertyValue("--animated-list-image-width").trim() || "500px";
			var targetGap = styles.getPropertyValue("--animated-list-image-gap").trim() || "2.5rem";

			var timeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 80%",
					end: "top 45%",
					scrub: 1,
				},
			})
				.to(wrapper, { width: targetWidth, marginRight: targetGap, ease: "power1.out" }, 0)
				.to(heading, { opacity: 1, ease: "power1.out" }, 0);

			if (timeline.scrollTrigger) triggers.push(timeline.scrollTrigger);
		});
	}

	function evaluate() {
		if (!gsap || !ScrollTrigger || reduceMotion.matches || mobileQuery.matches) {
			useStaticState();
		} else {
			useScrollEffect();
		}
	}

	evaluate();

	// Re-evaluate when crossing the mobile breakpoint or the reduced-motion
	// preference changes (e.g. rotating a tablet, or resizing a desktop
	// window down past 767px) instead of locking in whatever mode was active
	// on first load.
	[mobileQuery, reduceMotion].forEach(function (query) {
		if (typeof query.addEventListener === "function") {
			query.addEventListener("change", evaluate);
		} else if (typeof query.addListener === "function") {
			query.addListener(evaluate);
		}
	});

	// Also re-run on plain resize (debounced) while desktop/tablet-sized so
	// the expand target picks up the right --animated-list-image-width tier
	// when a window is dragged across the tablet/desktop boundary without
	// the mobile breakpoint being crossed.
	if (!gsap || !ScrollTrigger) return;

	var resizeTimeout;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			if (!mobileQuery.matches && !reduceMotion.matches) {
				useScrollEffect();
				ScrollTrigger.refresh();
			}
		}, 200);
	});
}

function initExpertiseCards() {
	var cards = Array.from(document.querySelectorAll("[data-expertise-card]"));
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");

	if (!cards.length) return;

	function setOpen(card, isOpen) {
		card.classList.toggle("is-open", isOpen);
		card.setAttribute("aria-expanded", isOpen ? "true" : "false");
	}

	function closeAll(exceptCard) {
		cards.forEach(function (card) {
			if (card === exceptCard) return;
			setOpen(card, false);
		});
	}

	cards.forEach(function (card) {
		card.addEventListener("click", function () {
			var willOpen;

			if (!mobileQuery.matches) return;

			willOpen = !card.classList.contains("is-open");
			closeAll(card);
			setOpen(card, willOpen);
		});
	});

	document.addEventListener("click", function (event) {
		if (!mobileQuery.matches) return;
		if (event.target.closest("[data-expertise-card]")) return;

		closeAll();
	});

	document.addEventListener("keydown", function (event) {
		if (event.key !== "Escape") return;

		closeAll();
	});

	if (mobileQuery.addEventListener) {
		mobileQuery.addEventListener("change", function () {
			if (mobileQuery.matches) return;

			closeAll();
		});
	} else if (mobileQuery.addListener) {
		mobileQuery.addListener(function () {
			if (mobileQuery.matches) return;

			closeAll();
		});
	}
}

function initOfficeLocations() {
	var blocks = Array.from(document.querySelectorAll("[data-office-locations]"));
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");

	blocks.forEach(function (block) {
		var media = block.querySelector(".s-office-locations__media");
		var currentImage = block.querySelector("[data-office-image-current]");
		var nextImageLayer = block.querySelector("[data-office-image-next]");
		var items = Array.from(block.querySelectorAll("[data-office-item]"));
		var toggles = Array.from(block.querySelectorAll("[data-office-toggle]"));
		var imageTransitionId = 0;
		var imageTransitionTimer = 0;
		var currentSource = currentImage ? currentImage.getAttribute("src") || "" : "";
		var pendingSource = currentSource;
		var activeItem = items.find(function (item) {
			return item.classList.contains("is-active");
		}) || items[0];

		if (!media || !currentImage || !nextImageLayer || !items.length) return;

		function getImage(item) {
			return item.getAttribute(mobileQuery.matches ? "data-office-mobile" : "data-office-desktop");
		}

		function syncExpandedState() {
			items.forEach(function (item) {
				var toggle = item.querySelector("[data-office-toggle]");

				if (!toggle) return;

				toggle.setAttribute("aria-expanded", item.classList.contains("is-active") ? "true" : "false");
			});
		}

		function updateImage(item) {
			var nextSource;
			var transitionId;
			var preloadImage;
			var didReveal = false;

			function resetPreviewLayer() {
				nextImageLayer.onload = null;
				nextImageLayer.onerror = null;
				nextImageLayer.setAttribute("src", currentSource);
				media.classList.remove("is-changing");
			}

			function finishTransition() {
				if (transitionId !== imageTransitionId) return;

				currentSource = nextSource;
				pendingSource = nextSource;
				currentImage.setAttribute("src", nextSource);
				resetPreviewLayer();
			}

			function revealNextImage() {
				if (didReveal) return;
				if (transitionId !== imageTransitionId) return;
				didReveal = true;

				nextImageLayer.setAttribute("src", nextSource);

				window.requestAnimationFrame(function () {
					if (transitionId !== imageTransitionId) return;

					media.classList.add("is-changing");
					imageTransitionTimer = window.setTimeout(finishTransition, 380);
				});
			}

			if (!item) return;
			nextSource = getImage(item);

			if (!nextSource) return;

			imageTransitionId += 1;
			transitionId = imageTransitionId;
			pendingSource = nextSource;
			window.clearTimeout(imageTransitionTimer);
			resetPreviewLayer();

			if (currentSource === nextSource) {
				pendingSource = currentSource;
				return;
			}

			preloadImage = new Image();
			preloadImage.onload = revealNextImage;
			preloadImage.onerror = function () {
				if (transitionId !== imageTransitionId) return;
				pendingSource = currentSource;
				resetPreviewLayer();
			};
			preloadImage.src = nextSource;

			if (preloadImage.complete) {
				revealNextImage();
			}
		}

		function setActive(item) {
			if (!item) return;

			items.forEach(function (office) {
				office.classList.toggle("is-active", office === item);
			});

			activeItem = item;
			syncExpandedState();
			updateImage(item);
		}

		function toggleMobileItem(item) {
			var willOpen;

			if (!item) return;

			willOpen = !item.classList.contains("is-active");

			items.forEach(function (office) {
				office.classList.toggle("is-active", office === item ? willOpen : false);
			});

			activeItem = item;
			syncExpandedState();
			updateImage(item);
		}

		items.forEach(function (item) {
			item.addEventListener("mouseenter", function () {
				if (mobileQuery.matches) return;

				setActive(item);
			});

			item.addEventListener("focusin", function () {
				if (mobileQuery.matches) return;

				setActive(item);
			});
		});

		toggles.forEach(function (toggle) {
			toggle.addEventListener("click", function () {
				var item = toggle.closest("[data-office-item]");

				if (!item) return;

				if (mobileQuery.matches) {
					toggleMobileItem(item);
					return;
				}

				setActive(item);
			});
		});

		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener("change", function () {
				if (!items.some(function (item) {
					return item.classList.contains("is-active");
				})) {
					setActive(activeItem || items[0]);
					return;
				}

				syncExpandedState();
				setActive(activeItem);
			});
		} else if (mobileQuery.addListener) {
			mobileQuery.addListener(function () {
				if (!items.some(function (item) {
					return item.classList.contains("is-active");
				})) {
					setActive(activeItem || items[0]);
					return;
				}

				syncExpandedState();
				setActive(activeItem);
			});
		}

		setActive(activeItem);
	});
}

function initSalesSectorMedia() {
	var mobileQuery = window.matchMedia("(max-width: 767.98px)");
	var blocks = Array.from(document.querySelectorAll("[data-sales-sector-nav]"));

	if (!blocks.length) return;

	blocks.forEach(function (block) {
		var section = block.closest(".s-local-office-sales-sectors");
		var media = section ? section.querySelector(".s-local-office-sales-sectors__media") : null;
		var currentImage = media ? media.querySelector("[data-sales-sector-image-current]") : null;
		var nextImage = media ? media.querySelector("[data-sales-sector-image-next]") : null;
		var triggers = Array.from(block.querySelectorAll("[data-sales-sector-trigger]"));
		var activeLink = triggers.find(function (link) {
			return link.classList.contains("is-active");
		}) || triggers[0] || null;
		var imageSwapId = null;

		if (!media || !currentImage || !nextImage || !triggers.length) return;

		function getImageSrc(link) {
			if (!link) return "";

			return link.getAttribute(
				mobileQuery.matches ? "data-sales-sector-mobile" : "data-sales-sector-desktop",
			) || "";
		}

		function syncState() {
			triggers.forEach(function (link) {
				var isActive = link === activeLink;
				link.classList.toggle("is-active", isActive);
				link.setAttribute("aria-pressed", isActive ? "true" : "false");
			});
		}

		function revealNextImage(src) {
			if (!src) return;

			if (imageSwapId) {
				clearTimeout(imageSwapId);
			}

			nextImage.src = src;
			media.classList.add("is-changing");

			imageSwapId = setTimeout(function () {
				currentImage.src = src;
				media.classList.remove("is-changing");
				imageSwapId = null;
			}, 250);
		}

		function setActive(link) {
			var src;

			if (!link) return;

			activeLink = link;
			syncState();
			src = getImageSrc(link);

			if (src && currentImage.getAttribute("src") !== src) {
				revealNextImage(src);
			}
		}

		triggers.forEach(function (link) {
			link.addEventListener("click", function () {
				setActive(link);
			});

			link.addEventListener("mouseenter", function () {
				if (mobileQuery.matches) return;
				setActive(link);
			});

			link.addEventListener("focusin", function () {
				if (mobileQuery.matches) return;
				setActive(link);
			});
		});

		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener("change", function () {
				if (!activeLink) return;
				currentImage.src = getImageSrc(activeLink) || currentImage.getAttribute("src");
				nextImage.src = currentImage.src;
				media.classList.remove("is-changing");
			});
		} else if (mobileQuery.addListener) {
			mobileQuery.addListener(function () {
				if (!activeLink) return;
				currentImage.src = getImageSrc(activeLink) || currentImage.getAttribute("src");
				nextImage.src = currentImage.src;
				media.classList.remove("is-changing");
			});
		}

		currentImage.src = getImageSrc(activeLink) || currentImage.getAttribute("src");
		nextImage.src = currentImage.src;
		syncState();
	});
}

function initTeamProfileReveal() {
	var targets = Array.from(document.querySelectorAll(".s-team__profile"));
	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

	if (!targets.length) return;

	function reveal(target) {
		target.classList.add("is-revealed");
	}

	if (reduceMotion.matches || !("IntersectionObserver" in window)) {
		targets.forEach(reveal);
		return;
	}

	var observer = new IntersectionObserver(
		function (entries, obs) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;

				reveal(entry.target);
				obs.unobserve(entry.target);
			});
		},
		{ root: null, rootMargin: "0px 0px -12% 0px", threshold: [0, 0.15] },
	);

	targets.forEach(function (target) {
		observer.observe(target);
	});
}

function initCountUpValues() {
	var targets = Array.from(document.querySelectorAll("[data-count-up]"));
	var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

	if (!targets.length) return;

	function formatValue(target, value) {
		var prefix = target.getAttribute("data-count-prefix") || "";
		var suffix = target.getAttribute("data-count-suffix") || "";

		return prefix + Math.round(value) + suffix;
	}

	function setFinalValue(target) {
		var finalValue = parseFloat(target.getAttribute("data-count-up")) || 0;
		target.textContent = formatValue(target, finalValue);
		target.dataset.countUpAnimated = "true";
	}

	function animateValue(target) {
		var finalValue;
		var duration;
		var startTime;

		if (target.dataset.countUpAnimated === "true") return;

		finalValue = parseFloat(target.getAttribute("data-count-up")) || 0;
		duration = finalValue >= 300 ? 1600 : 1400;
		startTime = null;
		target.textContent = formatValue(target, 0);

		function step(timestamp) {
			var progress;
			var easedProgress;
			var currentValue;

			if (startTime === null) {
				startTime = timestamp;
			}

			progress = Math.min((timestamp - startTime) / duration, 1);
			easedProgress = 1 - Math.pow(1 - progress, 3);
			currentValue = finalValue * easedProgress;
			target.textContent = formatValue(target, currentValue);

			if (progress < 1) {
				requestAnimationFrame(step);
				return;
			}

			setFinalValue(target);
		}

		requestAnimationFrame(step);
	}

	if (reduceMotion.matches || !("IntersectionObserver" in window)) {
		targets.forEach(setFinalValue);
		return;
	}

	targets.forEach(function (target) {
		target.textContent = formatValue(target, 0);
	});

	var observer = new IntersectionObserver(
		function (entries, obs) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;

				animateValue(entry.target);
				obs.unobserve(entry.target);
			});
		},
		{ root: null, rootMargin: "0px 0px -10% 0px", threshold: [0, 0.2] },
	);

	targets.forEach(function (target) {
		observer.observe(target);
	});
}

function initListingHeroSlider() {
	document.querySelectorAll("[data-listing-hero-slider]").forEach(function (slider) {
		var section = slider.closest(".s-listing-hero");
		var prev = section ? section.querySelector("[data-listing-hero-prev]") : null;
		var next = section ? section.querySelector("[data-listing-hero-next]") : null;

		new Swiper(slider, {
			slidesPerView: "auto",
			centeredSlides: true,
			loop: slider.querySelectorAll(".swiper-slide").length > 1,
			spaceBetween: 0,
			speed: 700,
			watchOverflow: true,
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
		});
	});
}

function initListingGallery() {
	var roots = Array.from(document.querySelectorAll("[data-listing-gallery-root]"));

	if (!roots.length) return;

	roots.forEach(function (root) {
		var sourceItems = Array.from(root.querySelectorAll("[data-listing-gallery-item]")).map(function (item) {
			return {
				src: item.getAttribute("data-gallery-src") || "",
				width: parseInt(item.getAttribute("data-gallery-width"), 10) || 0,
				height: parseInt(item.getAttribute("data-gallery-height"), 10) || 0,
				alt: item.getAttribute("data-gallery-alt") || "",
			};
		}).filter(function (item) {
			return item.src && item.width > 0 && item.height > 0;
		});

		if (!sourceItems.length) return;

		function openGallery(index) {
			var pswp = new PhotoSwipe({
				dataSource: sourceItems.map(function (item) {
					return {
						src: item.src,
						width: item.width,
						height: item.height,
						alt: item.alt,
					};
				}),
				index: Math.max(0, Math.min(index || 0, sourceItems.length - 1)),
				showHideAnimationType: "fade",
				bgOpacity: 0.92,
				loop: true,
				spacing: 0.12,
				initialZoomLevel: "fit",
				secondaryZoomLevel: 1.75,
				maxZoomLevel: 4,
			});

			pswp.init();
		}

		root.addEventListener("click", function (event) {
			var trigger = event.target.closest("[data-listing-gallery-open]");
			var index;

			if (!trigger || !root.contains(trigger)) return;

			event.preventDefault();
			index = parseInt(trigger.getAttribute("data-listing-gallery-open"), 10) || 0;
			openGallery(index);
		});
	});
}

function initLocalOfficeContactGallery() {
	var roots = Array.from(document.querySelectorAll("[data-local-contact-gallery-root]"));

	if (!roots.length) return;

	roots.forEach(function (root) {
		var slider = root.querySelector("[data-local-contact-gallery-slider]");
		var slides = slider ? slider.querySelectorAll(".swiper-slide") : [];
		var sourceItems = Array.from(root.querySelectorAll("[data-local-contact-gallery-item]")).map(function (item) {
			return {
				src: item.getAttribute("data-gallery-src") || "",
				width: parseInt(item.getAttribute("data-gallery-width"), 10) || 0,
				height: parseInt(item.getAttribute("data-gallery-height"), 10) || 0,
				alt: item.getAttribute("data-gallery-alt") || "",
			};
		}).filter(function (item) {
			return item.src && item.width > 0 && item.height > 0;
		});

		if (slider && slides.length) {
			new Swiper(slider, {
				slidesPerView: "auto",
				loop: slides.length > 1,
				centeredSlides: true,
				spaceBetween: 20,
				speed: 900,
				allowTouchMove: true,
				watchOverflow: true,
				autoplay: slides.length > 1 ? {
					delay: 6000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				} : false,
			});
		}

		if (!sourceItems.length) return;

		function openGallery(index) {
			var pswp = new PhotoSwipe({
				dataSource: sourceItems.map(function (item) {
					return {
						src: item.src,
						width: item.width,
						height: item.height,
						alt: item.alt,
					};
				}),
				index: Math.max(0, Math.min(index || 0, sourceItems.length - 1)),
				showHideAnimationType: "fade",
				bgOpacity: 0.92,
				loop: true,
				spacing: 0.12,
				initialZoomLevel: "fit",
				secondaryZoomLevel: 1.75,
				maxZoomLevel: 4,
			});

			pswp.init();
		}

		root.addEventListener("click", function (event) {
			var trigger = event.target.closest("[data-local-contact-gallery-open]");

			if (!trigger || !root.contains(trigger)) return;

			event.preventDefault();

			// TEMP: lightbox disabled on s-local-office-contact-gallery__inner —
			// uncomment below to re-enable.
			// var index = parseInt(trigger.getAttribute("data-local-contact-gallery-open"), 10) || 0;
			// openGallery(index);
		});
	});
}

function initCareersTestimonialsSlider() {
	document.querySelectorAll("[data-careers-testimonials-slider]").forEach(function (slider) {
		var section = slider.closest(".s-careers-testimonials");
		var prev = section ? section.querySelector("[data-careers-testimonials-prev]") : null;
		var next = section ? section.querySelector("[data-careers-testimonials-next]") : null;
		var count = section ? section.querySelector("[data-careers-testimonials-count]") : null;
		var total = slider.querySelectorAll(".swiper-slide").length;

		function updateSlideOpacity(instance) {
			instance.slides.forEach(function (slide) {
				var progress = Math.min(Math.abs(slide.progress || 0), 1);
				var opacity = Math.max(0, 1 - progress);
				slide.style.opacity = opacity.toFixed(3);
			});
		}

		var swiper = new Swiper(slider, {
			loop: true,
			slidesPerView: 1,
			autoHeight: true,
			spaceBetween: 40,
			speed: 700,
			allowTouchMove: true,
			watchOverflow: true,
			watchSlidesProgress: true,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			navigation: prev && next ? { prevEl: prev, nextEl: next } : undefined,
			on: {
				init: function (instance) {
					updateSlideOpacity(instance);
				},
				setTranslate: function (instance) {
					updateSlideOpacity(instance);
				},
			},
		});

		function updateCount() {
			if (!count) return;
			count.textContent = "".concat(swiper.realIndex + 1, "/").concat(total);
		}

		swiper.on("init", updateCount);
		swiper.on("slideChange", updateCount);
		swiper.on("slideChangeTransitionStart", function () {
			swiper.updateAutoHeight(700);
		});
		swiper.on("resize", function () {
			swiper.updateAutoHeight(0);
			updateSlideOpacity(swiper);
		});
		updateCount();
		updateSlideOpacity(swiper);
		swiper.updateAutoHeight(0);
	});
}

function initSalesNetworkSlider() {
	document.querySelectorAll("[data-sales-network-slider]").forEach(function (slider) {
		function updateSlideOpacity(instance) {
			instance.slides.forEach(function (slide) {
				var progress = Math.min(Math.abs(slide.progress || 0), 1);
				var opacity = Math.max(0, 1 - progress);
				slide.style.opacity = opacity.toFixed(3);
			});
		}

		var swiper = new Swiper(slider, {
			loop: true,
			slidesPerView: 1,
			autoHeight: true,
			spaceBetween: 40,
			speed: 700,
			allowTouchMove: true,
			watchOverflow: true,
			watchSlidesProgress: true,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			on: {
				init: function (instance) {
					updateSlideOpacity(instance);
				},
				setTranslate: function (instance) {
					updateSlideOpacity(instance);
				},
			},
		});

		swiper.on("slideChangeTransitionStart", function () {
			swiper.updateAutoHeight(700);
		});
		swiper.on("resize", function () {
			swiper.updateAutoHeight(0);
			updateSlideOpacity(swiper);
		});
		updateSlideOpacity(swiper);
		swiper.updateAutoHeight(0);
	});
}

function initGoogleMaps() {
	var roots = Array.from(document.querySelectorAll("[data-google-map]"));
	var config = getGoogleMapsConfig();

	if (!roots.length) return;
	if (!config.apiKey) return;

	loadGoogleMapsApi().then(function (maps) {
		if (!maps) return;

		roots.forEach(function (root) {
			var canvas = root.querySelector("[data-google-map-canvas]");
			var lat = parseFloat(root.getAttribute("data-google-map-lat"));
			var lng = parseFloat(root.getAttribute("data-google-map-lng"));
			var zoom = parseFloat(root.getAttribute("data-google-map-zoom")) || 10;
			var title = root.getAttribute("data-google-map-title") || "";
			var markerUrl = root.getAttribute("data-google-map-marker") || "img/map-pointer.png";
			var markerWidth = parseFloat(root.getAttribute("data-google-map-marker-width")) || 43;
			var markerHeight = parseFloat(root.getAttribute("data-google-map-marker-height")) || 63;
			var position;
			var map;

			if (!canvas || Number.isNaN(lat) || Number.isNaN(lng)) return;

			position = { lat: lat, lng: lng };
			map = new maps.Map(canvas, {
				center: position,
				zoom: zoom,
				mapId: config.mapId || undefined,
				styles: config.mapId ? undefined : GOOGLE_MAPS_WY_STYLE,
				disableDefaultUI: true,
				zoomControl: true,
				fullscreenControl: false,
				streetViewControl: false,
				mapTypeControl: false,
				clickableIcons: false,
				gestureHandling: "cooperative",
			});

			createGoogleMapsOverlayMarker(
				maps,
				map,
				new maps.LatLng(position.lat, position.lng),
				markerUrl,
				title,
				markerWidth,
				markerHeight,
			);

			root.classList.add("is-ready");
		});
	}).catch(function (error) {
		console.error(error);
	});
}

function initLocalOfficeNewsList() {
	var sections = Array.from(document.querySelectorAll("[data-local-office-news-list]"));

	if (!sections.length) return;

	sections.forEach(function (section) {
		var buttons = Array.from(section.querySelectorAll(".s-local-office-news-list__filters .b-page-nav__link"));
		var resultsWrap = section.querySelector(".s-local-office-news-list__results-wrap");
		var spinner = section.querySelector(".s-local-office-news-list__spinner");
		var grid = section.querySelector("[data-local-office-news-list-grid]");
		var requestId = 0;
		var loadingTimer = null;
		var revealTimer = null;
		var spinnerRaf = null;
		var spinnerLockedTop = "";
		var initialItems = grid ? Array.from(grid.children) : [];

		if (!buttons.length || !resultsWrap || !spinner || !grid || !initialItems.length) return;

		function updateSpinnerPosition() {
			if (spinnerLockedTop) {
				resultsWrap.style.setProperty("--local-office-news-spinner-top", spinnerLockedTop);
				return;
			}

			var rect = resultsWrap.getBoundingClientRect();
			var visibleTop = Math.max(rect.top, 0);
			var visibleBottom = Math.min(rect.bottom, window.innerHeight);
			var visibleHeight = Math.max(visibleBottom - visibleTop, 0);
			var centerInWrap = 0;

			if (!visibleHeight) {
				centerInWrap = Math.min(Math.max(window.innerHeight / 2 - rect.top, 20), Math.max(rect.height - 20, 20));
			} else {
				centerInWrap = ((visibleTop + visibleBottom) / 2) - rect.top;
			}

			resultsWrap.style.setProperty("--local-office-news-spinner-top", centerInWrap.toFixed(2) + "px");
		}

		function requestSpinnerPosition() {
			if (spinnerRaf) return;

			spinnerRaf = requestAnimationFrame(function () {
				updateSpinnerPosition();
				spinnerRaf = null;
			});
		}

		function setActiveButton(nextButton) {
			buttons.forEach(function (button) {
				var isActive = button === nextButton;
				button.classList.toggle("is-active", isActive);
				button.setAttribute("aria-pressed", isActive ? "true" : "false");
			});
		}

		function getItemsForFilter(index) {
			var rotated;
			var head;
			var tail;

			if (index <= 0) return initialItems.slice();

			rotated = initialItems.slice(index).concat(initialItems.slice(0, index));
			head = rotated.slice(0, 3);
			tail = rotated.slice(3);

			if (index % 2 !== 0) {
				head.reverse();
			}

			if (index % 3 === 0) {
				tail.reverse();
			}

			return head.concat(tail);
		}

		function renderItems(items) {
			var fragment = document.createDocumentFragment();

			items.forEach(function (item) {
				fragment.appendChild(item);
			});

			grid.appendChild(fragment);
		}

		function setLoading(nextState) {
			if (loadingTimer) {
				clearTimeout(loadingTimer);
				loadingTimer = null;
			}

			if (revealTimer) {
				clearTimeout(revealTimer);
				revealTimer = null;
			}

			if (nextState) {
				updateSpinnerPosition();
				spinnerLockedTop = resultsWrap.style.getPropertyValue("--local-office-news-spinner-top");
				section.classList.add("is-loading");
				section.classList.remove("is-results-pending");
				return;
			}

			section.classList.remove("is-loading");
			section.classList.add("is-results-pending");
			revealTimer = setTimeout(function () {
				spinnerLockedTop = "";
				section.classList.remove("is-results-pending");
				requestSpinnerPosition();
				revealTimer = null;
			}, 180);
		}

		function applyFilter(button, index) {
			var nextRequestId = requestId + 1;
			var nextItems = getItemsForFilter(index);
			requestId = nextRequestId;

			setActiveButton(button);
			setLoading(true);

			loadingTimer = setTimeout(function () {
				if (nextRequestId !== requestId) return;

				renderItems(nextItems);
				requestLenisResize();
				requestSpinnerPosition();
				setLoading(false);
			}, 320);
		}

		section.addEventListener("click", function (event) {
			var button = event.target.closest(".s-local-office-news-list__filters .b-page-nav__link");

			if (!button || !section.contains(button) || button.classList.contains("is-active")) return;

			applyFilter(button, buttons.indexOf(button));
		});

		window.addEventListener("scroll", requestSpinnerPosition, { passive: true });
		window.addEventListener("resize", requestSpinnerPosition);
		requestSpinnerPosition();
	});
}

function initFooterBackToTop() {
	var link = document.querySelector("[data-back-to-top]");

	if (!link) return;

	link.addEventListener("click", function (event) {
		event.preventDefault();

		if (window.lenis && typeof window.lenis.scrollTo === "function") {
			window.lenis.scrollTo(0);
			return;
		}

		window.scrollTo({ top: 0, behavior: "smooth" });
	});
}

function initListingAnchors() {
	var links = Array.from(document.querySelectorAll("[data-listing-anchor]"));

	if (!links.length) return;

	function getScrollOffset() {
		var header = document.querySelector(".header");
		var isMobile = window.matchMedia("(max-width: 767.98px)").matches;
		var headerHeight = header ? header.offsetHeight : 0;

		return headerHeight + (isMobile ? 16 : 24);
	}

	links.forEach(function (link) {
		link.addEventListener("click", function (event) {
			var targetSelector = link.getAttribute("href");
			var target;
			var offset;

			if (!targetSelector || targetSelector.charAt(0) !== "#") return;

			target = document.querySelector(targetSelector);
			if (!target) return;

			event.preventDefault();
			offset = getScrollOffset();

			if (window.lenis && typeof window.lenis.scrollTo === "function") {
				window.lenis.scrollTo(target, {
					offset: -offset,
				});
			} else {
				window.scrollTo({
					top: target.getBoundingClientRect().top + window.pageYOffset - offset,
					behavior: "smooth",
				});
			}

			if (history && typeof history.pushState === "function") {
				history.pushState(null, "", targetSelector);
			}
		});
	});
}

document.addEventListener("DOMContentLoaded", function () {
	suppressResizeObserverLoopError();
	enhanceButtons(document);
	initModals();
	initImageModals();
	initAccordions();
	initHeaderScroll();
	document.querySelectorAll("[data-header-tabs]").forEach(initHeaderTabs);
	initHeaderMobileMenu();
	initPageNav();
	initAnchorNavs();
	initLocalOfficeAboutPeopleTicker();
	initPartnersTicker();
	initLocalOfficeAboutStory();
	initContributorsList();
	initJournalFeed();
	initChronicleSliders();
	initHeaderFeatureSliders();
	initProducerSliders();
	initProducerMentionSliders();
	initEbooksSliders();
	initLocalOfficePropertiesSlider();
	initTextCarouselSlider();
	initKeyFeaturesSlider();
	initLoTeamCarouselSlider();
	initLocalOfficeTeamSlider();
	initLocalOfficeTeamDesktopRotation();
	initLocalOfficeNewsFeaturedSlider();
	initLocalOfficeNewsList();
	initLocalOfficeAboutNewsSlider();
	initNewsArticleLatestSlider();
	initListingHeroSlider();
	initListingGallery();
	initLocalOfficeContactGallery();
	initCareersTestimonialsSlider();
	initSalesNetworkSlider();
	initGoogleMaps();
	initListingAnchors();
	initFooterBackToTop();
	initSplitHeadings();
	initTeamProfileReveal();
	initHomeHeroAnimation();
	initHomePreloader();
	initHomeFilters();
	initHomeAutocomplete();
	initResponsivePlaceholders();
	initPropertyDropdowns();
	initParallaxMedia();
	initAnimatedFeaturesList();
	initExpertiseCards();
	initOfficeLocations();
	initSalesSectorMedia();
	initCountUpValues();
	initLenis();
});
